// Tamil translations for the business management application
export default {
  // Landing page translations
  landing: {
    hero: {
      badge: 'இந்திய SMEகளுக்காக',
      title: 'உங்கள் தொழிலை நடத்துங்கள்.',
      subtitle: 'காகித வேலை அல்ல.',
      description: 'இந்திய SMEகளுக்கான வரவிருக்கும் நிறுவன OS. உள்ளூர்-முதல் ஆடம்பரத்துடன் GST, சரக்கு மற்றும் வர்த்தக நிதியை எளிதாக்குங்கள்.',
      cta_waitlist: 'காத்திருப்பு பட்டியலில் சேரவும்',
      cta_demo: 'கட்டிடக்கலை பார்க்கவும்',
      trust_early: 'விரைவில் ஆரம்ப அணுகல்',
      trust_card: 'கிரெடிட் கார்டு தேவையில்லை',
      trust_gst: 'GST கவனம்',
      stats_revenue: 'வருவாய்',
      stats_inventory: 'சரக்கு'
    },
    social_proof: {
      stats: {
        smes: { value: 'இந்திய SMEகள்', label: 'உருவாக்குவது' },
        gst: { value: 'GST கவனம்', label: 'இணக்கம்' },
        cloud: { value: 'கிளவுட் நேட்டிவ்', label: 'கட்டிடக்கலை' },
        status: { value: 'ஆரம்ப அணுகல்', label: 'நிலை' }
      }
    },
    problem: {
      badge: 'முக்கிய சவால்கள்',
      title: 'உங்கள் வளர்ச்சியை',
      subtitle: 'தடுக்கும் உராய்வு.',
      description: "நவீன இந்திய வணிக நிலப்பரப்பு வேகமாக வளர்ந்து வருகிறது. மரபு கருவிகள் டிஜிட்டல் வர்த்தகம் மற்றும் GST சிக்கலின் வேகத்திற்காக உருவாக்கப்படவில்லை.",
      cards: {
        paperwork: {
          title: 'காகித வேலையில் இழந்த மணிநேரங்கள்',
          description: 'கைமுறை விலைப்பட்டியல், தரவு உள்ளீடு மற்றும் நல்லிணக்கம் ஒவ்வொரு வாரமும் 15+ மணிநேரத்தை சாப்பிடுகிறது. நீங்கள் வளர்ச்சியில் செலவிட வேண்டிய நேரம்.'
        },
        gst: {
          title: 'GST இணக்கத் தலைவலி',
          description: 'சரியான வரி விகிதங்களைக் கணக்கிடுவது, சரியான நேரத்தில் வருமானத்தை தாக்கல் செய்வது மற்றும் அபராதங்களைத் தவிர்ப்பது நிலையான தொழில்நுட்ப மற்றும் மன உளைச்சல்.'
        },
        inventory: {
          title: 'சரக்கு குருட்டு புள்ளிகள்',
          description: "ஸ்டாக்அவுட்கள் மற்றும் ஓவர்ஸ்டாக்கிங் நடக்கிறது, ஏனெனில் உங்கள் முழு கிடங்கு நெட்வொர்க்கிலும் உங்களுக்கு நிகழ்நேரத் தெரிவுநிலை இல்லை."
        }
      }
    },
    features: {
      title: 'நிறுவன சக்தி.',
      subtitle: 'உங்களுக்காக எளிமைப்படுத்தப்பட்டது.',
      description: 'சோமா தொழில்துறை தர கணக்கியலை நவீன வணிக உரிமையாளருக்காக வடிவமைக்கப்பட்ட தடையற்ற இடைமுகத்துடன் இணைக்கிறது.',
      cards: {
        invoicing: {
          title: 'GST விலைப்பட்டியல்',
          description: 'விநாடிகளில் GST-இணக்க விலைப்பட்டியல்களை உருவாக்க வடிவமைக்கப்பட்டுள்ளது. துல்லியமான உள்ளூர் இணக்கத்துடன் வரி விகிதங்களை தானாகக் கணக்கிடுங்கள்.'
        },
        inventory: {
          title: 'சரக்கு ஒத்திசைவு',
          description: 'பல நகர கிடங்குகளில் நிகழ்நேர பங்கு நிலைகளைக் கண்காணிக்கவும். சரக்கு ஆரோக்கியம் குறித்த முன்கணிப்பு விழிப்பூட்டல்கள்.'
        },
        intelligence: {
          title: 'வர்த்தக நுண்ணறிவு',
          description: 'எங்கள் உள்ளூர் கட்டமைப்பின் மூலம் அதிநவீன P&L, பணப்புழக்கம் மற்றும் வரி அறிக்கைகளை உருவாக்குங்கள்.'
        },
        mobile: {
          title: 'ஒருங்கிணைந்த மொபைல்',
          description: 'உங்கள் தொலைபேசியிலிருந்து உங்கள் முழு நிறுவனத்தையும் நிர்வகிக்கவும். நிறுவன சக்தி, நுகர்வோர் எளிமை.'
        }
      },
      learn_more: 'மேலும் அறிக'
    },
    cta: {
      badge: 'முன் வெளியீட்டு அணுகல்',
      title: 'எதிர்கால',
      subtitle: 'இந்திய வர்த்தகம்.',
      description: "சோமாவின் நிறுவன கட்டமைப்பை அனுபவிக்கும் முதல் நபர்களில் ஒருவராக இருங்கள். வேகம், அளவு மற்றும் உள்ளூர் இணக்கத்திற்காக கட்டப்பட்டது.",
      btn_waitlist: 'காத்திருப்பு பட்டியலில் சேரவும்',
      btn_features: 'அம்சங்களைப் பார்க்கவும்',
      benefits: {
        early_access: 'ஆரம்ப அணுகல்',
        priority: 'முன்னுரிமை ஆன்போர்டிங்',
        updates: 'புதுப்பிப்புகள் சேர்க்கப்பட்டுள்ளன'
      }
    },
    differentiation: {
      badge: 'ஓம்னிசேனல் கட்டமைப்பு',
      title: 'எங்கிருந்தும்',
      subtitle: 'வர்த்தகம் செய்யுங்கள்.',
      description: 'வாடிக்கையாளருடன் பேசும்போது உங்கள் தொலைபேசியில் விலைப்பட்டியலைத் தொடங்கவும், பின்னர் உங்கள் மடிக்கணினியில் முடிக்கவும் வடிவமைக்கப்பட்டுள்ளது. குறைந்த இணைப்பு உள்ள பகுதிகளில் கூட எல்லா சாதனங்களிலும் தரவு உடனடியாக ஒத்திசைக்கப்படும்.',
      items: {
        mobile: {
          title: 'மொபைல் ஃபர்ஸ்ட்',
          desc: 'இந்திய சந்தையில் அதிவேக வர்த்தகத்திற்காக வடிவமைக்கப்பட்டது.'
        },
        desktop: {
          title: 'டெஸ்க்டாப் ஸ்கேல்',
          desc: 'பெரிய சரக்கு செயல்பாடுகள் மற்றும் மொத்த வர்த்தக தீர்வு.'
        },
        sync: {
          title: 'ஆஃப்லைன் ஒத்திசைவு',
          desc: 'தரவு உள்ளூரில் சேமிக்கப்படுகிறது. நீங்கள் இணைந்தவுடன் ஒத்திசைவு நடக்கும்.'
        }
      },
      stats: {
        latency: { value: '< 1s', label: 'இலக்கு தாமதம்' },
        uptime: { value: '99.9%', label: 'இலக்கு இயக்க நேரம்' },
        crypto: { value: 'AES-256', label: 'கிரிப்டோ' }
      },
      sync_status: 'லைவ் ஒத்திசைவு'
    },
    faq: {
      badge: 'அறிவுத் தளம்',
      title: 'விவரங்களை',
      subtitle: 'தெளிவுபடுத்துதல்.',
      questions: {
        setup: {
          q: 'தொடங்கப்பட்ட பிறகு சோமாவை அமைக்க எவ்வளவு நேரம் ஆகும்?',
          a: 'சோமாவை 2 நிமிடங்களுக்குள் முழுமையாக அமைக்க வடிவமைக்கப்பட்டுள்ளது. உங்கள் வணிகப் பெயர் மற்றும் GST எண்ணைச் சேர்க்கவும், நீங்கள் உடனடியாக விலைப்பட்டியல்களை உருவாக்கத் தொடங்கலாம். Tally, Zoho அல்லது விரிதாள்களில் இருந்து இலவச இடப்பெயர்வு உதவியை வழங்கவும் நாங்கள் திட்டமிட்டுள்ளோம்.'
        },
        security: {
          q: 'எனது வணிகத் தரவு பாதுகாப்பானதா?',
          a: 'நிச்சயமாக. எல்லா தரவிற்கும் வங்கி அளவிலான 256-பிட் குறியாக்கத்தை நாங்கள் செயல்படுத்துகிறோம். உங்கள் தகவல் இந்தியாவில் உள்ள பாதுகாப்பான சேவையகங்களில் பல காப்புப்பிரதிகளுடன் சேமிக்கப்படும். நாங்கள் ISO 27001 சான்றளிக்கப்பட்ட மற்றும் முழுமையாக DPDP இணக்கமாக இருக்க உருவாக்குகிறோம்.'
        },
        knowledge: {
          q: 'எனக்கு கணக்கியல் அல்லது தொழில்நுட்ப அறிவு தேவையா?',
          a: 'இல்லை. சோமா வணிக உரிமையாளர்களுக்காக வடிவமைக்கப்பட்டுள்ளது, கணக்காளர்களுக்காக அல்ல. நீங்கள் வாட்ஸ்அப்பைப் பயன்படுத்த முடிந்தால், நீங்கள் சோமாவைப் பயன்படுத்த முடியும். நாங்கள் அனைத்து சிக்கலான GST கணக்கீடுகள், வரி வகைப்பாடுகள் மற்றும் இணக்கத் தேவைகளை தானாகவே கையாளுகிறோம்.'
        },
        offline: {
          q: 'எனக்கு இணைய இணைப்பு இல்லையென்றால் என்ன நடக்கும்?',
          a: 'சோமா ஆஃப்லைனிலும் வேலை செய்ய வடிவமைக்கப்பட்டுள்ளது. எங்கள் மொபைல் பயன்பாட்டில் நீங்கள் விலைப்பட்டியல்களை உருவாக்குதல், சரக்குகளைப் புதுப்பித்தல் மற்றும் விற்பனையைப் பதிவுசெய்வதைத் தொடரலாம். நீங்கள் மீண்டும் ஆன்லைனில் வந்தவுடன், எல்லாம் உங்கள் எல்லா சாதனங்களிலும் தானாகவே ஒத்திசைக்கப்படும்.'
        },
        migration: {
          q: 'Tally இலிருந்து எனது தற்போதைய தரவை நகர்த்த முடியுமா?',
          a: 'ஆம்! Tally, Zoho Books அல்லது Excel விரிதாள்களில் இருந்து உங்கள் வாடிக்கையாளர் தரவு, தயாரிப்பு பட்டியல் மற்றும் வரலாற்று பரிவர்த்தனைகளை தடையின்றி கையாள இறக்குமதி கருவிகளை நாங்கள் உருவாக்குகிறோம்.'
        }
      },
      cta: {
        title: 'கட்டிடக்கலை ஆதரவு',
        link: 'எங்கள் பொறியாளர்களைத் தொடர்பு கொள்ளுங்கள்'
      }
    },
    testimonials: {
      badge: 'எங்கள் கவனம்',
      title: 'ஒவ்வொரு இந்திய வணிகத்திற்கும்',
      subtitle: 'வடிவமைத்தல்.',
      description: 'மொத்த விற்பனையாளர்கள் முதல் உற்பத்தியாளர்கள் வரை, சோமா உங்கள் தனிப்பட்ட வர்த்தகத் தேவைகளுக்கு ஏற்ப வடிவமைக்கப்படுகிறது.',
      featured: {
        title: 'மொத்த விற்பனை மற்றும் விநியோகம்',
        description: 'மொத்த சரக்கு, சிக்கலான விலை நிலைகள் மற்றும் கடன் சுழற்சிகளை எளிதாக நிர்வகிக்கவும். சோமா அளவைக் கையாளக் கட்டமைக்கப்பட்டுள்ளது, எனவே நீங்கள் வர்த்தகத்தில் கவனம் செலுத்தலாம்.',
        badge: {
          title: 'மொத்த விற்பனை',
          desc: 'அதிக அளவு • குறைந்த லாபம்'
        },
        stats: {
          inventory: { label: 'சரக்கு', value: 'தொகுதி கண்காணிப்பு' },
          pricing: { label: 'விலை', value: 'பல அடுக்கு' },
          finance: { label: 'நிதி', value: 'கடன் மேலாண்மை' }
        }
      },
      industries: {
        manufacturing: {
          title: 'உற்பத்தி',
          description: 'மூலப்பொருட்கள், பொருட்கள் பட்டியல் (BOM) மற்றும் உற்பத்தி செலவுகளைத் துல்லியமாகக் கண்காணிப்பதை நோக்கமாகக் கொண்டுள்ளது.'
        },
        retail: {
          title: 'சில்லறை சங்கிலிகள்',
          description: 'திட்டமிடப்பட்ட ஒருங்கிணைந்த விற்பனை புள்ளி (POS), பார்கோடு ஸ்கேனிங் மற்றும் நிகழ்நேர பல கடை ஒத்திசைவு.'
        },
        service: {
          title: 'சேவை வழங்குநர்கள்',
          description: 'திட்டம் சார்ந்த பில்லிங், நேர கண்காணிப்பு மற்றும் தானியங்கி செலவு மேலாண்மைக்காக வடிவமைக்கப்பட்டுள்ளது.'
        }
      }
    },
    features_page: {
      badge: 'SME OS முக்கிய அம்சங்கள்',
      title: 'இதற்காக',
      subtitle: 'உருவாக்கப்பட்டது தடுக்க முடியாத SME.',
      description: 'நவீன SME களின் சிக்கல்களைத் தீர்க்க சோமா அடித்தளத்திலிருந்து உருவாக்கப்படுகிறது. GST ஐ தானியக்கமாக்குங்கள், சரக்குகளைக் கண்காணிக்கவும் மற்றும் ஒரே மேடையில் நிகழ்நேர நுண்ணறிவுகளைப் பெறுங்கள்.',
      cta_waitlist: 'காத்திருப்பு பட்டியலில் சேரவும்',
      cta_learn_more: 'மேலும் அறிக',
      engineered_workflows: 'பொறியியல் பணிப்பாய்வுகள்',
      testimonial: {
        quote: '"இறுதியாக, இந்திய வர்த்தகத்தின் சிக்கலைப் புரிந்துகொள்ளும் ஒரு வணிக OS. எங்கள் செயல்பாடுகளை சோமாவுக்கு மாற்ற நாங்கள் ஆவலுடன் காத்திருக்கிறோம்."',
        author: 'அங்கித் வார்ஷ்னி',
        role: 'CEO, வார்ஷ்னி டெக்ஸ்டைல்ஸ் (பீட்டா பார்ட்னர்)'
      },
      final_cta: {
        title: 'எதிர்காலத்தை அனுபவிக்க தயாரா?',
        description: 'இந்திய SME செயல்பாடுகளை மறுவரையறை செய்யும் தளத்தை அணுகும் முதல் நபர்களில் ஒருவராக இருங்கள். இன்று முன்கூட்டிய அணுகலைக் கோருங்கள்.',
        request_access: 'அணுகலைக் கோருங்கள்',
        view_plans: 'திட்டங்களைப் பாருங்கள்',
        footer: 'உள்ளூர்-முதல் • GST இணக்கமானது • எண்டர்பிரைஸ் ஸ்கேல்'
      },
      features: {
        gst: {
          title: 'GST இணக்கம்',
          description: 'இந்திய வரி சுற்றுச்சூழல் அமைப்பிற்காக வடிவமைக்கப்பட்ட தானியங்கி GST தாக்கல், விலைப்பட்டியல் உருவாக்கம் மற்றும் இணக்க கண்காணிப்பு.',
          benefits: {
            filing: 'தானியங்கி GSTR தாக்கல்',
            alerts: 'நிகழ்நேர இணக்க எச்சரிக்கைகள்',
            validation: 'விலைப்பட்டியல் சரிபார்ப்பு'
          }
        },
        inventory: {
          title: 'சரக்கு ஒத்திசைவு',
          description: 'ஸ்மார்ட் மறுவரிசை புள்ளிகள் மற்றும் பகுப்பாய்வுகளுடன் பல இடங்களில் நிகழ்நேர சரக்கு கண்காணிப்பு.',
          benefits: {
            tracking: 'பல இட கண்காணிப்பு',
            alerts: 'தானியங்கி மறுவரிசை எச்சரிக்கைகள்',
            analytics: 'பங்கு இயக்கம் பகுப்பாய்வு'
          }
        },
        analytics: {
          title: 'ஸ்மார்ட் அனலிட்டிக்ஸ்',
          description: 'தானியங்கி P&L மற்றும் பணப்புழக்க அறிக்கைகளுடன் உங்கள் வணிக செயல்திறனில் ஆழ்ந்த நுண்ணறிவுகளைப் பெறுங்கள்.',
          benefits: {
            pl: 'P&L அறிக்கைகள்',
            cashflow: 'பணப்புழக்க பகுப்பாய்வு',
            tax: 'வரி உகப்பாக்கம் நுண்ணறிவு'
          }
        },
        crm: {
          title: 'வாடிக்கையாளர் CRM',
          description: 'வரலாறு கண்காணிப்பு மற்றும் ஸ்மார்ட் ஈடுபாட்டின் மூலம் உங்கள் வாடிக்கையாளர்களுடன் நீடித்த உறவுகளை உருவாக்குங்கள்.',
          benefits: {
            profiles: 'வாடிக்கையாளர் சுயவிவரங்கள்',
            history: 'ஆர்டர் வரலாறு',
            logs: 'தகவல் தொடர்பு பதிவுகள்'
          }
        },
        global: {
          title: 'உலகளாவிய வர்த்தகம்',
          description: 'பல நாணய ஆதரவு மற்றும் FEMA-இணக்க விலைப்பட்டியல் பணிப்பாய்வுகளுடன் உலகளவில் விரிவுபடுத்துங்கள்.',
          benefits: {
            rates: 'நிகழ்நேர மாற்று விகிதங்கள்',
            invoicing: 'பல நாணய விலைப்பட்டியல்',
            compliance: 'FEMA இணக்கம்'
          }
        },
        security: {
          title: 'வங்கி-தர பாதுகாப்பு',
          description: 'உங்கள் வணிகத் தரவு மிக உயர்ந்த குறியாக்கத் தரநிலைகள் மற்றும் உள்ளூர் இணக்கத்தால் பாதுகாக்கப்படுகிறது.',
          benefits: {
            encryption: 'முனை-முதல்-முனை குறியாக்கம்',
            backups: 'வழக்கமான காப்புப்பிரதிகள்',
            compliance: 'இந்திய DPDP இணக்கம்'
          }
        }
      }
    },
    pricing_page: {
      badge: 'வெளிப்படையான விலை',
      title: 'எளிமையான, வெளிப்படையான விலை',
      subtitle: 'மறைக்கப்பட்ட கட்டணங்கள் இல்லை.',
      description: '14 நாள் இலவச சோதனையுடன் தொடங்குங்கள். கிரெடிட் கார்டு தேவையில்லை.',
      billing: {
        monthly: 'மாதாந்திர',
        yearly: 'வருடாந்திர',
        save: '20% சேமிக்கவும்'
      },
      per_month: '/மாதம்',
      yearly_discount: 'வருடாந்திர தள்ளுபடி',
      plans: {
        features_title: 'உள்ளடக்கிய அம்சங்கள்',
        per_month: '/மாதம்',
        recommended: 'அளவிடுவதற்குப் பரிந்துரைக்கப்படுகிறது',
        starter: {
          name: 'ஸ்டார்டர்',
          description: 'சிறு வணிகங்கள் மற்றும் வளர்ந்து வரும் ஸ்டார்ட்அப்களுக்கு ஏற்றது',
          cta: 'காத்திருப்பு பட்டியலில் சேரவும்',
          features: {
            invoices: 'மாதத்திற்கு 100 விலைப்பட்டியல்கள்',
            gst: 'அடிப்படை GST இணக்கம்',
            inventory: 'ஒற்றை இட சரக்கு',
            support: 'மின்னஞ்சல் ஆதரவு',
            reporting: 'அடிப்படை அறிக்கையிடல்',
            mobile: 'மொபைல் பயன்பாட்டு அணுகல்'
          }
        },
        professional: {
          name: 'தொழில்முறை',
          description: 'சிக்கலான தேவைகளைக் கொண்ட வளர்ந்து வரும் வணிகங்களுக்கு ஏற்றது',
          cta: 'காத்திருப்பு பட்டியலில் சேரவும்',
          features: {
            invoices: 'வரம்பற்ற விலைப்பட்டியல்கள்',
            gst: 'மேம்பட்ட GST இணக்கம்',
            inventory: 'பல இட சரக்கு',
            support: 'முன்னுரிமை ஆதரவு',
            analytics: 'மேம்பட்ட பகுப்பாய்வு',
            api: 'API அணுகல்',
            integrations: 'தனிப்பயன் ஒருங்கிணைப்புகள்',
            users: 'பல பயனர் அணுகல்'
          }
        },
        enterprise: {
          name: 'எண்டர்பிரைஸ்',
          description: 'குழு பணிப்பாய்வுகளைக் கொண்ட பெரிய அளவிலான வணிகங்களுக்கு',
          cta: 'முன்கூட்டிய அணுகலுக்கு தொடர்பு கொள்ளவும்',
          features: {
            all_pro: 'தொழில்முறையில் உள்ள அனைத்தும்',
            manager: 'அர்ப்பணிக்கப்பட்ட கணக்கு மேலாளர்',
            workflows: 'தனிப்பயன் பணிப்பாய்வுகள்',
            security: 'மேம்பட்ட பாதுகாப்பு அம்சங்கள்',
            whitelabel: 'வெள்ளை-லேபிள் விருப்பங்கள்',
            access: 'பங்கு அடிப்படையிலான அணுகல்',
            reporting: 'தனிப்பயன் அறிக்கையிடல்',
            deployment: 'ஆன்-பிரைமைஸ் வரிசைப்படுத்தல்'
          }
        }
      },
      faq: {
        badge: 'FAQ',
        title: 'கேள்விகள்',
        subtitle: 'பில்லிங் மற்றும் விலை நிர்ணயம் பற்றி நீங்கள் தெரிந்து கொள்ள வேண்டிய அனைத்தும்.',
        questions: {
          trial: {
            q: 'இலவச சோதனை இருக்குமா?',
            a: 'ஆம்! தொடங்கப்பட்டதும், அனைத்து திட்டங்களும் 14 நாள் இலவச சோதனையுடன் வரும். அனைத்து அம்சங்களுக்கும் முழு அணுகலைப் பெறுவீர்கள், எனவே சோமா உங்கள் வணிகத்திற்கு கொண்டு வரும் மதிப்பை நீங்கள் காணலாம். கிரெடிட் கார்டு தேவைப்படாது.'
          },
          change: {
            q: 'நான் எப்போது வேண்டுமானாலும் திட்டங்களை மாற்றலாமா?',
            a: 'நிச்சயமாக. நீங்கள் எப்போது வேண்டுமானாலும் உங்கள் திட்டத்தை மேம்படுத்தலாம் அல்லது தரமிறக்கலாம். நீங்கள் மேம்படுத்தும்போது, புதிய அம்சங்கள் உடனடியாக கிடைக்கும்.'
          },
          payment: {
            q: 'எந்த கட்டண முறைகள் ஏற்றுக்கொள்ளப்படும்?',
            a: 'அனைத்து முக்கிய கிரெடிட் கார்டுகள், டெபிட் கார்டுகள், UPI, நெட் பேங்கிங் மற்றும் PhonePe, Paytm மற்றும் Google Pay உள்ளிட்ட இந்தியாவில் பிரபலமான டிஜிட்டல் பணப்பைகளை ஏற்க திட்டமிட்டுள்ளோம்.'
          },
          security: {
            q: 'எனது தரவு பாதுகாப்பானதா?',
            a: 'ஆம், நாங்கள் எண்டர்பிரைஸ்-கிரேடு 256-பிட் SSL குறியாக்கத்தைப் பயன்படுத்துகிறோம். உங்கள் வணிகத் தரவு பாதுகாப்பாக இருப்பதை உறுதிசெய்ய நாங்கள் SOC2 இணக்கமாகவும் அனைத்து இந்திய தரவு பாதுகாப்பு விதிமுறைகளையும் (DPDP) பின்பற்றுகிறோம்.'
          }
        }
      },
      final_cta: {
        title: 'தயாரா',
        subtitle: 'தீவிர அளவுக்கு?',
        book_call: 'கட்டமைப்பு அழைப்பை பதிவு செய்யவும்',
        contact_sales: 'விற்பனையைத் தொடர்பு கொள்ளவும்',
        footer: 'சோமாவை வரிசைப்படுத்துங்கள். பாரம்பரியத்தை உருவாக்குங்கள்.'
      }
    },
  },
  solutions_page: {
        badge: 'தொழில் குறிப்பிட்ட DNA',
        title: 'தனிப்பயனாக்கப்பட்டது',
        subtitle: 'உங்கள் அளவுக்காக.',
        description: 'உங்கள் வணிகம் தனித்துவமானது என்பதால் பொதுவான மென்பொருள் தோல்வியடைகிறது. சோமா உங்கள் தொழில் குறிப்பிட்ட பணிப்பாய்வுகளுக்கு ஏற்றது.',
        cta_contact: 'விற்பனையைத் தொடர்பு கொள்ளவும்',
        cta_case_studies: 'வழக்கு ஆய்வுகளைப் பார்க்கவும்',
        core_workflow: 'முக்கிய பணிப்பாய்வு கூறுகள்',
        top_users: 'சிறந்த தொழில் பயனர்கள்',
        validated_results: 'சரிபார்க்கப்பட்ட முடிவுகள்',
        deployment: 'நிறுவன வரிசைப்படுத்தல்',
        built_for_scale: 'சிக்கலான இந்திய அளவுக்காக கட்டப்பட்டது.',
        industries: {
          retail: {
            title: 'Retail & E-commerce',
            description: 'ஒருங்கிணைந்த சரக்கு மற்றும் பல சேனல் பில்லிங் மூலம் உங்கள் சில்லறை வணிகத்தை அளவிடவும்.',
            features: {
              inventory: 'பல சேனல் சரக்கு ஒத்திசைவு',
              pos: 'விற்பனை புள்ளி (POS) ஒருங்கிணைப்பு',
              loyalty: 'விசுவாசம் & பரிசு அட்டைகள்',
              reordering: 'தானியங்கி பங்கு மறுவரிசைப்படுத்தல்'
            },
            tags: {
              fashion: 'ஃபேஷன்',
              electronics: 'எலெக்ட்ரானிக்ஸ்',
              chains: 'சில்லறை சங்கிலிகள்'
            },
            proof: {
              label: 'பங்கு குறைப்பு',
              company: 'ஃபேஷன் சில்லறை'
            }
          },
          manufacturing: {
            title: 'Manufacturing',
            description: 'ஸ்மார்ட் செலவு கண்காணிப்பு மற்றும் மூலப்பொருள் பணிப்பாய்வுகளுடன் உற்பத்தியை மேம்படுத்தவும்.',
            features: {
              planning: 'உற்பத்தி திட்டமிடல் (MRP)',
              bom: 'BOM மேலாண்மை',
              waste: 'கழிவு & சிதைவு கண்காணிப்பு',
              labor: 'தொழிலாளர் செலவு ஒதுக்கீடு'
            },
            tags: {
              auto: 'ஆட்டோ பாகங்கள்',
              textile: 'ஜவுளி ஆலைகள்',
              food: 'உணவு தொழில்நுட்பம்'
            },
            proof: {
              label: 'கழிவு குறைப்பு',
              company: 'உற்பத்தி'
            }
          },
          services: {
            title: 'Services & Agencies',
            description: 'கிளையண்ட் பில்லிங் மற்றும் திட்ட லாபத்தை சிரமமின்றி நெறிப்படுத்தவும்.',
            features: {
              accounting: 'திட்டம் சார்ந்த கணக்கியல்',
              portal: 'பணம் செலுத்துவதற்கான கிளையண்ட் போர்டல்',
              tracking: 'விலைப்பட்டியலுக்கான நேர கண்காணிப்பு',
              billing: 'தொடர்ச்சியான சேவை பில்லிங்'
            },
            tags: {
              it: 'IT ஏஜென்சிகள்',
              law: 'சட்ட நிறுவனங்கள்',
              consulting: 'ஆலோசனை'
            },
            proof: {
              label: 'வேகமான பில்லிங்',
              company: 'சேவை ஏஜென்சி'
            }
          },
          healthcare: {
            title: 'Healthcare',
            description: 'மருத்துவ நடைமுறைகள் மற்றும் ஆய்வகங்களுக்கான இணக்க-தயாரான பின்-அலுவலக கருவிகள்.',
            features: {
              inventory: 'மருத்துவ சரக்கு கட்டுப்பாடு',
              claims: 'காப்பீட்டு கோரிக்கை கண்காணிப்பு',
              billing: 'நோயாளி பில்லிங் ஆட்டோமேஷன்',
              reporting: 'ஒழுங்குமுறை அறிக்கையிடல்'
            },
            tags: {
              clinics: 'கிளினிக்குகள்',
              pharmacies: 'மருந்தகங்கள்',
              labs: 'ஆய்வகங்கள்'
            },
            proof: {
              label: 'பில்லிங் துல்லியம்',
              company: 'சுகாதாரம்'
            }
          }
        },
        cta_section: {
          title_prefix: 'உங்கள்',
          title_suffix: 'தீர்வு DNA ஐக் கண்டுபிடிக்க தயாரா?',
          book_audit: 'கட்டிடக்கலை தணிக்கையை பதிவு செய்யவும்',
          talk_expert: 'நிபுணரிடம் பேசுங்கள்',
          footer_text: 'உள்ளூரில் வரிசைப்படுத்துங்கள். உலகளவில் அளவிடுங்கள்.'
        }
      },
    resources_page: {
      badge: 'சோமா அறிவு மையம்',
      title_prefix: 'கற்றுக்கொள்ளுங்கள்',
      title_suffix: 'செழிக்கவும்',
      description: 'நீங்கள் தடுக்க முடியாத இந்திய SME ஐ உருவாக்க உதவும் பிரத்யேக வழிகாட்டிகள், தொழில் நுண்ணறிவு மற்றும் தொழில்நுட்ப ஆவணங்கள்.',
      ledger: {
        title: 'தி லெட்ஜர்',
        subtitle: 'SME அளவு மற்றும் உள்ளூர்-முதல் கட்டிடக்கலை பற்றிய ஒரு இதழ்.',
        cta: 'காப்பகத்தை ஆராயுங்கள்'
      },
      implementation: {
        title_prefix: 'செயலாக்கம்',
        title_suffix: 'தேர்ச்சி',
        description: 'எங்கள் கட்டிடக்கலைஞர்கள் பெரிய அளவிலான நிறுவன வரிசைப்படுத்தல்கள் மற்றும் தனிப்பயன் உற்பத்தி பணிப்பாய்வுகளுக்கான பிரத்யேக அமர்வுகளை வழங்குகிறார்கள்.',
        cta_training: 'பயிற்சியைத் திட்டமிடுங்கள்',
        cta_support: 'தொழில்நுட்ப ஆதரவு',
        footer: 'கட்டிடக்கலை • ஒருங்கிணைப்பு • அளவு'
      },
      cards: {
        quick_start: {
          title: "விரைவு தொடக்க வழிகாட்டி",
          description: "10 நிமிடங்களுக்குள் சோமாவுடன் உங்கள் பயணத்தைத் தொடங்க உங்களுக்குத் தேவையான அனைத்தும்.",
          tag: "அவசியம்"
        },
        mastering_gst: {
          title: "GST இல் தேர்ச்சி பெறுதல்",
          description: "GSTR ஆட்டோமேஷன், இ-வே பில்கள் மற்றும் உள்ளூர் வரி இணக்கம் ஆகியவற்றில் ஆழ்ந்த ஆய்வு.",
          tag: "புதுப்பிக்கப்பட்டது 2026"
        },
        inventory_strategy: {
          title: "சரக்கு உத்தி",
          description: "சோமாவின் பல இட ஒத்திசைவைப் பயன்படுத்தி வி.கே. பிரிண்ட்ஸ் 400% வளர்ச்சியை எவ்வாறு நிர்வகித்தது.",
          tag: "வழக்கு ஆய்வு"
        },
        api_docs: {
          title: "API ஆவணங்கள்",
          description: "தனிப்பயன் ஒருங்கிணைப்புகளை உருவாக்கி சோமாவின் திறன்களை விரிவுபடுத்துங்கள்.",
          tag: "தொழில்நுட்பம்"
        },
        community: {
          title: "சமூக மன்றம்",
          description: "பிற வணிக உரிமையாளர்கள் மற்றும் சோமா நிபுணர்களுடன் இணையுங்கள்.",
            tag: "வெளிப்புறம்"
          },
          webinar: {
            title: "வெபினார்: GST 2026",
            description: "புதிய வரி விதிகள் குறித்த எங்கள் சமீபத்திய அமர்வின் பதிவைப் பாருங்கள்.",
            tag: "புதியது"
          }
        }
      },
  // Layout translations
  layout: {
    navbar: {
      login: 'உள்நுழைவு',
      get_started: 'தொடங்கவும்',
      dashboard: 'டாஷ்போர்டு',
      links: {
        features: 'அம்சங்கள்',
        pricing: 'விலை',
        solutions: 'தீர்வுகள்',
        resources: 'வளங்கள்'
      }
    },
    footer: {
      brand_desc: 'இந்திய நிறுவனங்களின் அளவிற்காக வடிவமைக்கப்பட்ட பிரீமியம் வணிக இயக்க முறைமை.',
      engineered_for: 'பொறியியல்',
      excellence: 'சிறப்பு',
      sections: {
        product: 'தயாரிப்பு',
        company: 'நிறுவனம்',
        resources: 'வளங்கள்',
        legal: 'சட்டம்'
      },
      links: {
        features: 'அம்சங்கள்',
        pricing: 'விலை',
        solutions: 'தீர்வுகள்',
        resources: 'வளங்கள்',
        about: 'பற்றி',
        blog: 'வலைப்பதிவு',
        careers: 'தொழில்',
        contact: 'தொடர்பு',
        docs: 'ஆவணங்கள்',
        help: 'உதவி மையம்',
        api: 'API குறிப்பு',
        status: 'நிலை',
        privacy: 'தனியுரிமை',
        terms: 'விதிமுறைகள்',
        security: 'பாதுகாப்பு'
      },
      copyright: 'சோமா டெக்னாலஜிஸ். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.'
    }
  },
  // Common UI elements
  common: {
    loading: 'ஏற்றுகிறது...',
    save: 'சேமிக்கவும்',
    cancel: 'ரத்து செய்யவும்',
    delete: 'நீக்கவும்',
    edit: 'திருத்தவும்',
    add: 'சேர்க்கவும்',
    create: 'உருவாக்கவும்',
    update: 'புதுப்பிக்கவும்',
    search: 'தேடவும்',
    filter: 'வடிகட்டவும்',
    export: 'ஏற்றுமதி',
    import: 'இறக்குமதி',
    print: 'அச்சிடவும்',
    download: 'பதிவிறக்கவும்',
    upload: 'பதிவேற்றவும்',
    submit: 'சமர்ப்பிக்கவும்',
    reset: 'மீட்டமைக்கவும்',
    clear: 'அழிக்கவும்',
    confirm: 'உறுதிப்படுத்தவும்',
    yes: 'ஆம்',
    no: 'இல்லை',
    ok: 'சரி',
    close: 'மூடவும்',
    back: 'பின்னால்',
    next: 'அடுத்து',
    previous: 'முந்தைய',
    finish: 'முடிக்கவும்',
    continue: 'தொடரவும்',
    skip: 'தவிர்க்கவும்',
    retry: 'மீண்டும் முயற்சிக்கவும்',
    refresh: 'புதுப்பிக்கவும்',
    view: 'பார்க்கவும்',
    details: 'விவரங்கள்',
    settings: 'அமைப்புகள்',
    help: 'உதவி',
    about: 'பற்றி',
    contact: 'தொடர்பு',
    support: 'ஆதரவு',
    feedback: 'கருத்து',
    logout: 'வெளியேறவும்',
    login: 'உள்நுழைவு',
    register: 'பதிவு செய்யவும்',
    profile: 'சுயவிவரம்',
    account: 'கணக்கு',
    dashboard: 'டாஷ்போர்டு',
    home: 'முகப்பு',
    menu: 'மெனு',
    navigation: 'வழிசெலுத்தல்',
    sidebar: 'பக்கப்பட்டி',
    header: 'தலைப்பு',
    footer: 'அடிப்பகுதி',
    content: 'உள்ளடக்கம்',
    main: 'முக்கிய',
    section: 'பிரிவு',
    page: 'பக்கம்',
    tab: 'தாவல்',
    panel: 'பேனல்',
    modal: 'மோடல்',
    dialog: 'உரையாடல்',
    form: 'படிவம்',
    field: 'புலம்',
    input: 'உள்ளீடு',
    select: 'தேர்ந்தெடுக்கவும்',
    option: 'விருப்பம்',
    checkbox: 'சரிபார்ப்பு பெட்டி',
    radio: 'ரேடியோ',
    button: 'பொத்தான்',
    link: 'இணைப்பு',
    image: 'படம்',
    icon: 'ஐகான்',
    text: 'உரை',
    title: 'தலைப்பு',
    description: 'விளக்கம்',
    name: 'பெயர்',
    email: 'மின்னஞ்சல்',
    phone: 'தொலைபேசி',
    address: 'முகவரி',
    city: 'நகரம்',
    state: 'மாநிலம்',
    country: 'நாடு',
    zipcode: 'அஞ்சல் குறியீடு',
    date: 'தேதி',
    time: 'நேரம்',
    datetime: 'தேதி மற்றும் நேரம்',
    status: 'நிலை',
    type: 'வகை',
    category: 'வகை',
    priority: 'முன்னுரிமை',
    quantity: 'அளவு',
    price: 'விலை',
    amount: 'தொகை',
    total: 'மொத்தம்',
    subtotal: 'துணை மொத்தம்',
    tax: 'வரி',
    discount: 'தள்ளுபடி',
    currency: 'நாணயம்',
    unit: 'அலகு',
    notes: 'குறிப்புகள்',
    comments: 'கருத்துகள்',
    tags: 'குறிச்சொற்கள்',
    actions: 'செயல்கள்',
    options: 'விருப்பங்கள்',
    preferences: 'விருப்பத்தேர்வுகள்',
    configuration: 'கட்டமைப்பு',
    advanced: 'மேம்பட்ட',
    basic: 'அடிப்படை',
    general: 'பொது',
    security: 'பாதுகாப்பு',
    privacy: 'தனியுரிமை',
    notifications: 'அறிவிப்புகள்',
    alerts: 'எச்சரிக்கைகள்',
    warnings: 'எச்சரிக்கைகள்',
    errors: 'பிழைகள்',
    success: 'வெற்றி',
    info: 'தகவல்',
    tips: 'குறிப்புகள்',
    guides: 'வழிகாட்டிகள்',
    tutorials: 'பயிற்சிகள்',
    documentation: 'ஆவணங்கள்',
    faq: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
    terms: 'விதிமுறைகள்',
    conditions: 'நிபந்தனைகள்',
    policy: 'கொள்கை',
    agreement: 'ஒப்பந்தம்',
    license: 'உரிமம்',
    version: 'பதிப்பு',
    active: 'செயலில்',
    inactive: 'செயலற்ற',
    pending: 'நிலுவையில்',
    completed: 'முடிந்தது',
    failed: 'தோல்வி',
    cancelled: 'ரத்து செய்யப்பட்டது',
    approved: 'அங்கீகரிக்கப்பட்டது',
    rejected: 'நிராகரிக்கப்பட்டது',
    draft: 'வரைவு',
    published: 'வெளியிடப்பட்டது',
    archived: 'காப்பகப்படுத்தப்பட்டது',
    deleted: 'நீக்கப்பட்டது',
    new: 'புதிய',
    old: 'பழைய',
    recent: 'சமீபத்திய',
    latest: 'சமீபத்திய',
    popular: 'பிரபலமான',
    featured: 'சிறப்பம்சம்',
    recommended: 'பரிந்துரைக்கப்பட்ட',
    trending: 'டிரெண்டிங்',
    high: 'உயர்',
    medium: 'நடுத்தர',
    low: 'குறைந்த',
    urgent: 'அவசர',
    normal: 'சாதாரண',
    critical: 'முக்கியமான',
    important: 'முக்கியமான',
    optional: 'விருப்பமான',
    required: 'தேவையான',
    mandatory: 'கட்டாயமான',
    public: 'பொது',
    private: 'தனிப்பட்ட',
    shared: 'பகிரப்பட்ட',
    personal: 'தனிப்பட்ட',
    business: 'வணிகம்',
    professional: 'தொழில்முறை',
    enterprise: 'நிறுவனம்',
    premium: 'பிரீமியம்',
    free: 'இலவசம்',
    paid: 'கட்டணம்',
    trial: 'சோதனை',
    demo: 'டெமோ',
    beta: 'பீட்டா',
    alpha: 'ஆல்பா',
    stable: 'நிலையான',
    development: 'மேம்பாடு',
    production: 'உற்பத்தி',
    testing: 'சோதனை',
    staging: 'மேடையமைப்பு',
    maintenance: 'பராமரிப்பு',
    backup: 'காப்பு',
    restore: 'மீட்டமை',
    sync: 'ஒத்திசை',
    migrate: 'இடம்பெயர்',
    transfer: 'மாற்றம்',
    copy: 'நகல்',
    move: 'நகர்த்து',
    duplicate: 'நகல்',
    clone: 'குளோன்',
    merge: 'இணை',
    split: 'பிரி',
    combine: 'இணைக்க',
    separate: 'பிரி',
    group: 'குழு',
    ungroup: 'குழுவிலிருந்து நீக்கு',
    sort: 'வரிசைப்படுத்து',
    order: 'ஆர்டர்',
    arrange: 'ஏற்பாடு செய்',
    organize: 'ஒழுங்கமை',
    manage: 'நிர்வகி',
    control: 'கட்டுப்பாடு',
    monitor: 'கண்காணி',
    track: 'கண்காணி',
    analyze: 'பகுப்பாய்வு',
    report: 'அறிக்கை',
    statistics: 'புள்ளிவிவரங்கள்',
    metrics: 'அளவீடுகள்',
    analytics: 'பகுப்பாய்வு',
    insights: 'நுண்ணறிவு',
    trends: 'போக்குகள்',
    patterns: 'வடிவங்கள்',
    data: 'தரவு',
    information: 'தகவல்',
    content: 'உள்ளடக்கம்',
    media: 'ஊடகம்',
    files: 'கோப்புகள்',
    documents: 'ஆவணங்கள்',
    images: 'படங்கள்',
    videos: 'வீடியோக்கள்',
    audio: 'ஆடியோ',
    attachments: 'இணைப்புகள்',
    downloads: 'பதிவிறக்கங்கள்',
    uploads: 'பதிவேற்றங்கள்',
    storage: 'சேமிப்பு',
    memory: 'நினைவகம்',
    cache: 'கேச்',
    database: 'தரவுத்தளம்',
    server: 'சர்வர்',
    client: 'வாடிக்கையாளர்',
    network: 'நெட்வொர்க்',
    internet: 'இணையம்',
    connection: 'இணைப்பு',
    bandwidth: 'அலைவரிசை',
    speed: 'வேகம்',
    performance: 'செயல்திறன்',
    optimization: 'மேம்படுத்தல்',
    efficiency: 'திறன்',
    quality: 'தரம்',
    reliability: 'நம்பகத்தன்மை',
    stability: 'நிலைத்தன்மை',
    safety: 'பாதுகாப்பு',
    protection: 'பாதுகாப்பு',
    encryption: 'குறியாக்கம்',
    authentication: 'அங்கீகாரம்',
    authorization: 'அங்கீகாரம்',
    permission: 'அனுமதி',
    access: 'அணுகல்',
    rights: 'உரிமைகள்',
    privileges: 'சலுகைகள்',
    roles: 'பாத்திரங்கள்',
    users: 'பயனர்கள்',
    groups: 'குழுக்கள்',
    teams: 'அணிகள்',
    organizations: 'அமைப்புகள்',
    companies: 'நிறுவனங்கள்',
    departments: 'துறைகள்',
    divisions: 'பிரிவுகள்',
    branches: 'கிளைகள்',
    locations: 'இடங்கள்',
    regions: 'பகுதிகள்',
    countries: 'நாடுகள்',
    languages: 'மொழிகள்',
    currencies: 'நாணயங்கள்',
    timezones: 'நேர மண்டலங்கள்',
    formats: 'வடிவங்கள்',
    templates: 'வார்ப்புருக்கள்',
    themes: 'தீம்கள்',
    styles: 'பாணிகள்',
    layouts: 'தளவமைப்புகள்',
    designs: 'வடிவமைப்புகள்',
    colors: 'நிறங்கள்',
    fonts: 'எழுத்துருக்கள்',
    sizes: 'அளவுகள்',
    dimensions: 'பரிமாணங்கள்',
    positions: 'நிலைகள்',
    alignments: 'சீரமைப்புகள்',
    margins: 'விளிம்புகள்',
    padding: 'பேடிங்',
    borders: 'எல்லைகள்',
    shadows: 'நிழல்கள்',
    effects: 'விளைவுகள்',
    animations: 'அனிமேஷன்கள்',
    transitions: 'மாற்றங்கள்',
    interactions: 'தொடர்புகள்',
    gestures: 'சைகைகள்',
    shortcuts: 'குறுக்குவழிகள்',
    hotkeys: 'ஹாட்கீகள்',
    commands: 'கட்டளைகள்',
    functions: 'செயல்பாடுகள்',
    features: 'அம்சங்கள்',
    capabilities: 'திறன்கள்',
    tools: 'கருவிகள்',
    utilities: 'பயன்பாடுகள்',
    widgets: 'விட்ஜெட்கள்',
    components: 'கூறுகள்',
    modules: 'தொகுதிகள்',
    plugins: 'செருகுநிரல்கள்',
    extensions: 'நீட்டிப்புகள்',
    addons: 'கூடுதல்கள்',
    integrations: 'ஒருங்கிணைப்புகள்',
    connections: 'இணைப்புகள்',
    apis: 'ஏபிஐகள்',
    services: 'சேவைகள்',
    applications: 'பயன்பாடுகள்',
    software: 'மென்பொருள்',
    hardware: 'வன்பொருள்',
    devices: 'சாதனங்கள்',
    platforms: 'தளங்கள்',
    systems: 'அமைப்புகள்',
    frameworks: 'கட்டமைப்புகள்',
    libraries: 'நூலகங்கள்',
    packages: 'தொகுப்புகள்',
    dependencies: 'சார்புகள்',
    requirements: 'தேவைகள்',
    specifications: 'விவரக்குறிப்புகள்',
    standards: 'தரநிலைகள்',
    protocols: 'நெறிமுறைகள்',
    schemas: 'திட்டங்கள்',
    structures: 'கட்டமைப்புகள்',
    models: 'மாதிரிகள்',
    entities: 'நிறுவனங்கள்',
    objects: 'பொருள்கள்',
    items: 'பொருட்கள்',
    elements: 'கூறுகள்',
    parts: 'பாகங்கள்',
    pieces: 'துண்டுகள்',
    fragments: 'துண்டுகள்',
    sections: 'பிரிவுகள்',
    chapters: 'அத்தியாயங்கள்',
    pages: 'பக்கங்கள்',
    articles: 'கட்டுரைகள்',
    posts: 'இடுகைகள்',
    entries: 'உள்ளீடுகள்',
    records: 'பதிவுகள்',
    logs: 'பதிவுகள்',
    history: 'வரலாறு',
    timeline: 'காலவரிசை',
    schedule: 'அட்டவணை',
    calendar: 'நாட்காட்டி',
    events: 'நிகழ்வுகள்',
    appointments: 'சந்திப்புகள்',
    meetings: 'கூட்டங்கள்',
    conferences: 'மாநாடுகள்',
    calls: 'அழைப்புகள்',
    messages: 'செய்திகள்',
    emails: 'மின்னஞ்சல்கள்',
    reminders: 'நினைவூட்டல்கள்',
    tasks: 'பணிகள்',
    todos: 'செய்ய வேண்டியவை',
    projects: 'திட்டங்கள்',
    workflows: 'பணிப்பாய்வுகள்',
    processes: 'செயல்முறைகள்',
    procedures: 'நடைமுறைகள்',
    steps: 'படிகள்',
    stages: 'நிலைகள்',
    phases: 'கட்டங்கள்',
    milestones: 'மைல்கற்கள்',
    deadlines: 'காலக்கெடுக்கள்',
    goals: 'இலக்குகள்',
    objectives: 'நோக்கங்கள்',
    targets: 'இலக்குகள்',
    achievements: 'சாதனைகள்',
    results: 'முடிவுகள்',
    outcomes: 'விளைவுகள்',
    outputs: 'வெளியீடுகள்',
    inputs: 'உள்ளீடுகள்',
    resources: 'வளங்கள்',
    assets: 'சொத்துக்கள்',
    materials: 'பொருட்கள்',
    supplies: 'விநியோகங்கள்',
    equipment: 'உபகரணங்கள்',
    instruments: 'கருவிகள்',
    machines: 'இயந்திரங்கள்',
    vehicles: 'வாகனங்கள்',
    facilities: 'வசதிகள்',
    buildings: 'கட்டிடங்கள்',
    rooms: 'அறைகள்',
    spaces: 'இடங்கள்',
    areas: 'பகுதிகள்',
    zones: 'மண்டலங்கள்',
    done: 'முடிந்தது',
    undone: 'முடிக்கப்படாத',
    accomplished: 'நிறைவேற்றப்பட்ட',
    unaccomplished: 'நிறைவேற்றப்படாத'
  },

  // Navigation
  navigation: {
    home: 'முகப்பு',
    dashboard: 'டாஷ்போர்டு',
    inventory: 'சரக்கு',
    orders: 'ஆர்டர்கள்',
    customers: 'வாடிக்கையாளர்கள்',
    suppliers: 'சப்ளையர்கள்',
    purchases: 'வாங்குதல்கள்',
    analytics: 'பகுப்பாய்வு',
    reports: 'அறிக்கைகள்',
    settings: 'அமைப்புகள்',
    profile: 'சுயவிவரம்',
    logout: 'வெளியேறு',
    help: 'உதவி',
    support: 'ஆதரவு'
  },

  // Authentication
  auth: {
    login: 'உள்நுழைவு',
    register: 'பதிவு',
    logout: 'வெளியேறு',
    forgotPassword: 'கடவுச்சொல் மறந்துவிட்டதா',
    resetPassword: 'கடவுச்சொல் மீட்டமை',
    changePassword: 'கடவுச்சொல் மாற்று',
    email: 'மின்னஞ்சல்',
    password: 'கடவுச்சொல்',
    confirmPassword: 'கடவுச்சொல் உறுதிப்படுத்தல்',
    rememberMe: 'என்னை நினைவில் வைத்துக்கொள்',
    loginButton: 'உள்நுழை',
    registerButton: 'பதிவு செய்',
    alreadyHaveAccount: 'ஏற்கனவே கணக்கு உள்ளதா?',
    dontHaveAccount: 'கணக்கு இல்லையா?',
    signInHere: 'இங்கே உள்நுழையவும்',
    signUpHere: 'இங்கே பதிவு செய்யவும்',
    invalidCredentials: 'தவறான மின்னஞ்சல் அல்லது கடவுச்சொல்',
    accountCreated: 'கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது',
    passwordResetSent: 'கடவுச்சொல் மீட்டமை இணைப்பு உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்டது',
    passwordChanged: 'கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது',
    login_page: {
      title: 'நிறுவன இயக்க முறைமை.',
      features: {
        speed: { title: 'உள்ளூர் வேகம்', desc: 'இந்திய சந்தைக்காக கட்டமைக்கப்பட்ட உயர் செயல்திறன் கட்டமைப்பு.' },
        trust: { title: 'மறைகுறியாக்கப்பட்ட நம்பிக்கை', desc: 'உங்கள் முக்கியமான நிதித் தரவிற்கான வங்கி-தர பாதுகாப்பு நெறிமுறைகள்.' }
      },
      serving: '10,000+ இந்திய நிறுவனங்களுக்கு சேவை செய்கிறது',
      welcome: 'வரவேற்கிறோம்.',
      subtitle: 'அங்கீகரிக்கப்பட்ட அணுகல் மட்டும். உங்கள் சான்றுகளைச் சரிபார்க்கவும்.',
      email_label: 'மின்னஞ்சல் கட்டமைப்பு',
      password_label: 'பாதுகாப்பு விசை',
      reset_access: 'அணுகலை மீட்டமை',
      submit: 'டாஷ்போர்டைத் தொடங்கவும்',
      verifying: 'சான்றுகளைச் சரிபார்க்கிறது...',
      third_party: 'மூன்றாம் தரப்பு அங்கீகாரம்',
      verify_google: 'Google மூலம் சரிபார்க்கவும்',
      no_account: 'கணக்கு இல்லையா?',
      open_account: 'நிறுவன கணக்கைத் திறக்கவும்'
    },
    register_page: {
      title: 'எலைட் அடுக்கில் சேரவும்.',
      features: {
        gst: { title: 'GST உகந்ததாக்கப்பட்டது', desc: 'நிறுவன-தர இணக்க இயந்திரம்.' },
        sync: { title: 'அணு ஒத்திசைவு', desc: 'சாதனங்களில் உடனடி தரவு பரவல்.' }
      },
      testimonial: '"2 முதல் 20 இடங்களுக்கு அளவிட எங்களுக்குத் தேவையான உள்கட்டமைப்பு சோமா."',
      testimonial_author: 'ராஜேஷ் குமார்',
      testimonial_role: 'உரிமையாளர், குளோபல் டிரேடர்ஸ்',
      form_title: 'கணக்கைத் திறக்கவும்.',
      form_subtitle: 'எலைட் 14 நாள் சோதனையுடன் உங்கள் வணிக கட்டமைப்பைப் பாதுகாக்கவும்.',
      labels: {
        first_name: 'முதல் பெயர்',
        last_name: 'கடைசி பெயர்',
        email: 'கார்ப்பரேட் மின்னஞ்சல்',
        password: 'பாதுகாப்பு விசை',
        confirm_password: 'விசையை உறுதிப்படுத்தவும்',
        business_name: 'வணிக அடையாளம்',
        phone: 'தொலைபேசி எண்',
        entity_type: 'நிறுவன வகை',
        sector: 'துறை'
      },
      placeholders: {
        select_type: 'வகையைத் தேர்ந்தெடுக்கவும்',
        select_industry: 'தொழிலைத் தேர்ந்தெடுக்கவும்'
      },
      submit: 'அணுகலைக் கோருங்கள்',
      already_registered: 'ஏற்கனவே பதிவு செய்துள்ளீர்களா?',
      sign_in: 'அங்கீகரிக்கப்பட்ட உள்நுழைவு'
    }
  },

  // Business Management
  business: {
    profile: "வணிக சுயவிவரம்",
    edit_profile: "சுயவிவரத்தைத் திருத்தவும்",
    create_profile: "வணிக சுயவிவரத்தை உருவாக்கவும்",
    edit_business_profile: "வணிக சுயவிவரத்தைத் திருத்தவும்",
    create_business_profile: "வணிக சுயவிவரத்தை உருவாக்கவும்",
    no_profile_found: "வணிக சுயவிவரம் எதுவும் காணப்படவில்லை",
    no_business_profile: "வணிக சுயவிவரம் இல்லை",
    no_business_profile_description: "உங்கள் வணிக சுயவிவரத்தை நீங்கள் இன்னும் அமைக்கவில்லை. அனைத்து அம்சங்களையும் திறக்க ஒன்றை உருவாக்கவும்.",
    go_back: "திரும்பிச் செல்",
    basic_info: "அடிப்படை தகவல்",
    business_name: "வணிக பெயர்",
    enter_name: "வணிக பெயரை உள்ளிடவும்",
    business_type: "வணிக வகை",
    select_type: "வணிக வகையைத் தேர்ந்தெடுக்கவும்",
    email: "மின்னஞ்சல்",
    enter_email: "மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    phone: "தொலைபேசி",
    enter_phone: "தொலைபேசி எண்ணை உள்ளிடவும்",
    address: "முகவரி",
    enter_address: "முழு முகவரியை உள்ளிடவும்",
    category: "வகை",
    select_category: "வகையைத் தேர்ந்தெடுக்கவும்",
    annual_turnover: "ஆண்டு வருவாய்",
    select_turnover: "வருவாய் வரம்பைத் தேர்ந்தெடுக்கவும்",
    turnover_range_0_5L: "₹0 - ₹5 லட்சம்",
    turnover_range_5L_20L: "₹5 லட்சம் - ₹20 லட்சம்",
    turnover_range_20L_1Cr: "₹20 லட்சம் - ₹1 கோடி",
    turnover_range_1Cr_plus: "₹1 கோடி+",
    fetch_profile_error: "வணிக சுயவிவரத்தைப் பெற முடியவில்லை",
    fetch_gst_error: "GST அமைப்புகளைப் பெற முடியவில்லை",
    toggle_gst_error: "GST அம்சங்களை மாற்ற முடியவில்லை",
    update_gst_status_error: "GST நிலையைப் புதுப்பிக்க முடியவில்லை",
    save_error: "மாற்றங்களைச் சேமிக்க முடியவில்லை",
    gst_registered: "GST பதிவு செய்யப்பட்டது",
    gst_number: "GST எண்",
    registration_date: "பதிவு தேதி",
    flower_vendor: "பூ வியாபாரி",
    grocery_store: "மளிகைக் கடை",
    textile_shop: "ஜவுளி கடை",
    hardware_store: "வன்பொருள் கடை",
    electronics_shop: "எலெக்ட்ரானிக்ஸ் கடை",
    other: "மற்றவை",
    retailer: "சில்லறை விற்பனையாளர்",
    wholesaler: "மொத்த விற்பனையாளர்",
    manufacturer: "உற்பத்தியாளர்",
    service_provider: "சேவை வழங்குநர்",
    gst_configuration: "GST கட்டமைப்பு",
    enabled: "இயக்கப்பட்டது",
    disabled: "முடக்கப்பட்டது",
    gstin_number: "GSTIN எண்",
    gstin_placeholder: "22AAAAA0000A1Z5",
    gst_registration_date: "GST பதிவு தேதி",
    default_cgst: "இயல்புநிலை CGST (%)",
    default_sgst: "இயல்புநிலை SGST (%)",
    default_igst: "இயல்புநிலை IGST (%)",
    auto_sync: "GST போர்ட்டலுடன் விலைப்பட்டியல்களைத் தானாக ஒத்திசைக்கவும்",
    business_settings: "வணிக அமைப்புகள்",
    manage_business_preferences: "உங்கள் வணிக விருப்பங்களையும் கட்டமைப்புகளையும் நிர்வகிக்கவும்",
    general_settings: "பொது அமைப்புகள்",
    configure_general_settings: "அடிப்படை வணிக அமைப்புகளை கட்டமைக்கவும்",
    language: "மொழி",
    select_language: "மொழியைத் தேர்ந்தெடுக்கவும்",
    currency: "நாணயம்",
    select_currency: "நாணயத்தைத் தேர்ந்தெடுக்கவும்",
    timezone: "நேர மண்டலம்",
    select_timezone: "நேர மண்டலத்தைத் தேர்ந்தெடுக்கவும்",
    notifications: "அறிவிப்புகள்",
    manage_notification_preferences: "உங்கள் அறிவிப்பு விருப்பங்களை நிர்வகிக்கவும்",
    low_stock_alerts: "குறைந்த இருப்பு எச்சரிக்கைகள்",
    low_stock_description: "சரக்கு குறைவாக இருக்கும்போது அறிவிக்கப்படும்",
    expiring_items: "காலாவதியாகும் பொருட்கள்",
    expiring_items_description: "காலாவதியாகும் பொருட்கள் குறித்து அறிவிக்கப்படும்",
    order_updates: "ஆர்டர் புதுப்பிப்புகள்",
    order_updates_description: "புதிய ஆர்டர்கள் மற்றும் நிலை மாற்றங்கள் குறித்து அறிவிக்கப்படும்",
    save_changes: "மாற்றங்களைச் சேமி",
    saving: "சேமிக்கிறது...",
    cancel: "ரத்துசெய்",
    create_profile_btn: "சுயவிவரத்தை உருவாக்கு",
    yes: "ஆம்",
    no: "இல்லை",
    n_a: "N/A",
    settings_saved_successfully: "அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன",
    failed_to_save_settings: "அமைப்புகளைச் சேமிக்க முடியவில்லை",
    failed_to_load_settings: "அமைப்புகளை ஏற்ற முடியவில்லை",
    profile_updated: "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    business_profile_created: "வணிக சுயவிவரம் வெற்றிகரமாக உருவாக்கப்பட்டது!",
    error_saving: "சேமிக்கும் போது பிழை ஏற்பட்டது",
    error_creating: "சுயவிவரத்தை உருவாக்கும் போது பிழை ஏற்பட்டது",
    could_not_fetch_business_profile: "வணிக சுயவிவரத்தைப் பெற முடியவில்லை",
    business_profile_not_found: "வணிக சுயவிவரம் காணப்படவில்லை",
    not_provided: "வழங்கப்படவில்லை",
    business_label: "வணிகம்"
  },
    profile_settings: {
    title: 'அமைப்புகள்',
    description: 'உங்கள் கணக்கு மற்றும் தள முன்னுரிமைகளை நிர்வகிக்கவும்.',
    my_profile: 'என் சுயவிவரம்',
    my_profile_desc: 'தனிப்பட்ட தகவல் மற்றும் அவதார்',
    preferences: 'முன்னுரிமைகள்',
    preferences_desc: 'தீம், மொழி மற்றும் அறிவிப்புகள்',
    security_privacy: 'பாதுகாப்பு மற்றும் தனியுரிமை',
    security_privacy_desc: 'கடவுச்சொல் மற்றும் அணுகல் பாதுகாப்பு',
    active_sessions: 'செயலில் உள்ள அமர்வுகள்',
    active_sessions_desc: 'உள்நுழைந்த சாதனங்களை நிர்வகிக்கவும்',
    sign_out: 'வெளியேறு',
    profile_details: 'சுயவிவர விவரங்கள்',
    profile_details_desc: 'உங்கள் புகைப்படம் மற்றும் தனிப்பட்ட தகவலைப் புதுப்பிக்கவும்.',
    verified_account: 'சரிபார்க்கப்பட்ட கணக்கு',
    premium_plan: 'பிரீமியம் திட்டம்',
    first_name: 'முதல் பெயர்',
    last_name: 'கடைசி பெயர்',
    email_address: 'மின்னஞ்சல் முகவரி',
    saving: 'சேமிக்கிறது...',
    save_profile_changes: 'சுயவிவர மாற்றங்களைச் சேமிக்கவும்',
    preferences_title: 'முன்னுரிமைகள்',
    preferences_page_desc: 'தளத்தில் உங்கள் அனுபவத்தைத் தனிப்பயனாக்கவும்.',
    appearance: 'தோற்றம்',
    theme: 'தீம்',
    select_theme: 'தீமைத் தேர்ந்தெடுக்கவும்',
    light_mode: 'லைட் மோட்',
    dark_mode: 'டார்க் மோட்',
    system_default: 'கணினி இயல்புநிலை',
    display_language: 'காட்சி மொழி',
    select_language: 'மொழியைத் தேர்ந்தெடுக்கவும்',
    notifications: 'அறிவிப்புகள்',
    email_notifications: 'மின்னஞ்சல் அறிவிப்புகள்',
    email_notifications_desc: 'மின்னஞ்சல் மூலம் புதுப்பிப்புகளைப் பெறவும்',
    push_notifications: 'புஷ் அறிவிப்புகள்',
    push_notifications_desc: 'உலாவியின் அறிவிப்புகளைப் பெறவும்',
    sms_notifications: 'எஸ்எம்எஸ் அறிவிப்புகள்',
    sms_notifications_desc: 'எஸ்எம்எஸ் மூலம் புதுப்பிப்புகளைப் பெறவும்',
    save_preferences: 'முன்னுரிமைகளைச் சேமிக்கவும்',
    security_privacy_header: 'பாதுகாப்பு மற்றும் தனியுரிமை',
    security_privacy_header_desc: 'பாதுகாப்பான கடவுச்சொல்லுடன் உங்கள் கணக்கை வலுப்படுத்தவும்.',
    current_password: 'தற்போதைய கடவுச்சொல்',
    new_password: 'புதிய கடவுச்சொல்',
    confirm_password: 'கடவுச்சொல்லை உறுதிப்படுத்தவும்',
    updating: 'புதுப்பிக்கப்படுகிறது...',
    change_password: 'கடவுச்சொல்லை மாற்றவும்',
    advanced_security: 'மேம்பட்ட பாதுகாப்பு',
    advanced_security_desc: 'இந்த கணக்கிற்கான அனைத்து உள்நுழைவு முயற்சிகளுக்கும் பல காரணி அங்கீகாரம் தேவை.',
    enable_2fa: '2FA அங்கீகாரத்தை இயக்கவும் →',
    customization_underway: 'தனிப்பயனாக்கம் நடைபெறுகிறது',
    customization_underway_desc: 'உங்கள் அனுபவத்தின் மீது முழு கட்டுப்பாட்டை உங்களுக்கு வழங்க நாங்கள் நுணுக்கமான அறிவிப்பு கட்டுப்பாடுகள் மற்றும் சாதன நிர்வாகத்தை உருவாக்குகிறோம்.'
  },

  // Inventory Management
  inventory: {
    items: 'பொருட்கள்',
    item: 'பொருள்',
    product: 'தயாரிப்பு',
    service: 'சேவை',
    sku: 'எஸ்கேயூ',
    barcode: 'பார்கோடு',
    category: 'வகை',
    brand: 'பிராண்ட்',
    unit: 'அலகு',
    quantity: 'அளவு',
    price: 'விலை',
    cost: 'செலவு',
    sellingPrice: 'விற்பனை விலை',
    purchasePrice: 'வாங்குதல் விலை',
    stock: 'சரக்கு',
    lowStock: 'குறைந்த சரக்கு',
    outOfStock: 'சரக்கு இல்லை',
    inStock: 'சரக்கு உள்ளது',
    stockAlert: 'சரக்கு எச்சரிக்கை',
    reorderLevel: 'மீண்டும் ஆர்டர் நிலை',
    maxStock: 'அதிகபட்ச சரக்கு',
    minStock: 'குறைந்தபட்ச சரக்கு',
    addItem: 'பொருள் சேர்',
    editItem: 'பொருள் திருத்து',
    deleteItem: 'பொருள் நீக்கு',
    bulkImport: 'மொத்த இறக்குமதி',
    bulkExport: 'மொத்த ஏற்றுமதி',
    stockUpdate: 'சரக்கு புதுப்பிப்பு',
    stockAdjustment: 'சரக்கு சரிசெய்தல்',
    stockTransfer: 'சரக்கு மாற்றம்'
  },

  // Time formatting
  time: {
    justNow: 'இப்போது',
    minutesAgo: '{{count}} நிமிடங்களுக்கு முன்',
    hoursAgo: '{{count}} மணி நேரங்களுக்கு முன்',
    daysAgo: '{{count}} நாட்களுக்கு முன்',
    weeksAgo: '{{count}} வாரங்களுக்கு முன்',
    monthsAgo: '{{count}} மாதங்களுக்கு முன்',
    yearsAgo: '{{count}} ஆண்டுகளுக்கு முன்'
  },

  // Pluralization
  items: {
    one: '{{count}} பொருள்',
    other: '{{count}} பொருட்கள்'
  },

  customers: {
    one: '{{count}} வாடிக்கையாளர்',
    other: '{{count}} வாடிக்கையாளர்கள்'
  },

  orders: {
    one: '{{count}} ஆர்டர்',
    other: '{{count}} ஆர்டர்கள்'
  },

  dashboard: {
    "dashboard": "முதன்மை பக்கம்",
    "welcome": "வரவேற்பு",
    "business_overview": "வணிக கண்ணோட்டம்",
    "action_required": "நடவடிக்கை தேவை",
    "profile_incomplete_message": "உங்கள் வணிக சுயவிவரம் முழுமையடையவில்லை. தொடர தேவையான விவரங்களை வழங்கவும்.",
    "complete_profile": "சுயவிவரத்தை முடிக்கவும்",
    "quick_actions": "விரைவு நடவடிக்கைகள்",
    "add_sale": "விற்பனையைச் சேர்",
    "manage_stock": "பங்கு நிர்வகி",
    "view_orders": "ஆணைகளைக் காண்க",
    "todays_overview": "இன்றைய கண்ணோட்டம்",
    "weeks_overview": "இந்த வார கண்ணோட்டம்",
    "months_overview": "இந்த மாத கண்ணோட்டம்",
    "low_stock": "குறைந்த பங்கு",
    "total_value": "மொத்த மதிப்பு",
    "business_management": "வணிக மேலாண்மை",
    "inventory_management": "சரக்கு மேலாண்மை",
    "inventory_management_subtitle": "தயாரிப்புகள் மற்றும் பங்குகளை நிர்வகிக்கவும்",
    "order_management": "ஆணை மேலாண்மை",
    "order_management_subtitle": "ஆணைகளைக் கண்காணித்து நிறைவேற்றவும்",
    "purchase_management": "கொள்முதல் மேலாண்மை",
    "purchase_management_subtitle": "கொள்முதல்களைக் கண்காணித்து நிர்வகிக்கவும்",
    "customer_management": "வாடிக்கையாளர் மேலாண்மை",
    "customer_management_subtitle": "வாடிக்கையாளர் உறவுகளை நிர்வகிக்கவும்",
    "supplier_management": "சப்ளையர் மேலாண்மை",
    "supplier_management_subtitle": "சப்ளையர் உறவுகளை நிர்வகிக்கவும்",
    "business_analytics": "வணிக பகுப்பாய்வு",
    "business_analytics_subtitle": "செயல்திறன் அளவீடுகளைக் காண்க"
  },
  settings: {
    "settingsTitle": "அமைப்புகள்",
    "inventorySection": "சரக்கு",
    "lowStockThresholdLabel": "குறைந்த பங்கு வரம்பு",
    "lowStockThresholdDescription": "ஒரு எச்சரிக்கை தூண்டப்படுவதற்கு முன் குறைந்தபட்ச பங்கு நிலை.",
    "stockAlertsLabel": "பங்கு எச்சரிக்கைகள்",
    "stockAlertsDescription": "குறைந்த பங்கிற்கு அறிவிப்புகளைப் பெறுங்கள்.",
    "autoReorderLabel": "தானாக மறு ஆர்டர்",
    "autoReorderDescription": "பங்கு குறைவாக இருக்கும்போது தானாக கொள்முதல் ஆர்டர்களை உருவாக்கவும்.",
    "ordersSection": "ஆர்டர்கள்",
    "autoConfirmOrdersLabel": "ஆர்டர்களை தானாக உறுதிப்படுத்தவும்",
    "autoConfirmOrdersDescription": "உள்வரும் ஆர்டர்களை தானாகவே அங்கீகரித்து செயலாக்கவும்.",
    "defaultPaymentMethodLabel": "இயல்புநிலை கட்டண முறை",
    "defaultPaymentMethodDescription": "புதிய ஆர்டர்களுக்கு இயல்புநிலை கட்டண முறையை அமைக்கவும்.",
    "orderNumberPrefixLabel": "ஆர்டர் எண் முன்னொட்டு",
    "orderNumberPrefixDescription": "அனைத்து ஆர்டர் எண்களுக்கும் ஒரு தனிப்பயன் முன்னொட்டு (எ.கா., 'ORD-').",
    "invoicingSection": "விலைப்பட்டியல்",
    "autoGenerateInvoicesLabel": "தானாக விலைப்பட்டியல்களை உருவாக்கவும்",
    "autoGenerateInvoicesDescription": "ஒவ்வொரு ஆர்டருக்கும் தானாக ஒரு புதிய விலைப்பட்டியலை உருவாக்கவும்.",
    "invoiceNumberPrefixLabel": "விலைப்பட்டியல் எண் முன்னொட்டு",
    "invoiceNumberPrefixDescription": "அனைத்து விலைப்பட்டியல் எண்களுக்கும் ஒரு தனிப்பயன் முன்னொட்டு (எ.கா., 'INV-').",
    "defaultTaxRateLabel": "இயல்புநிலை வரி விகிதம் (%)",
    "defaultTaxRateDescription": "புதிய விலைப்பட்டியல்களுக்குப் பயன்படுத்தப்படும் இயல்புநிலை வரி விகிதம்.",
    "paymentTermsLabel": "கட்டண விதிமுறைகள்",
    "paymentTermsDescription": "விலைப்பட்டியல்களுக்கான இயல்புநிலை கட்டண விதிமுறைகள் (எ.கா., 'நிகர 30').",
    "reportingSection": "அறிக்கையிடல்",
    "autoEmailReportsLabel": "அறிக்கைகளை தானாக மின்னஞ்சல் செய்யவும்",
    "autoEmailReportsDescription": "உங்கள் மின்னஞ்சல் முகவரிக்கு திட்டமிடப்பட்ட அறிக்கைகளை அனுப்பவும்.",
    "defaultReportPeriodLabel": "இயல்புநிலை அறிக்கை காலம்",
    "defaultReportPeriodDescription": "அனைத்து அறிக்கைகளுக்கும் இயல்புநிலை காலத்தை அமைக்கவும் (எ.கா., 'மாதாந்திர', 'வாராந்திர').",
    "reportFormatLabel": "அறிக்கை வடிவம்",
    "reportFormatDescription": "அறிக்கைகளுக்கான இயல்புநிலை கோப்பு வடிவமைப்பைத் தேர்வுசெய்க (எ.கா., 'PDF', 'CSV').",
    "loadSettingsError": "அமைப்புகளை ஏற்றுவதில் தோல்வி: {{message}}",
    "updateFailedError": "புதுப்பிப்பு தோல்வியடைந்தது",
    "invalidInputError": "தவறான உள்ளீடு",
    "enterValidNumberError": "தயவுசெய்து சரியான எண்ணை உள்ளிடவும்.",
    "selectOption": "தேர்ந்தெடு",
    "paymentMethodCash": "பணம்",
    "paymentMethodCard": "அட்டை",
    "paymentMethodUPI": "UPI",
    "paymentMethodBankTransfer": "வங்கி பரிமாற்றம்",
    "reportPeriodDaily": "தினசரி",
    "reportPeriodWeekly": "வாராந்திர",
    "reportPeriodMonthly": "மாதாந்திர",
    "reportPeriodQuarterly": "காலாண்டு",
    "reportFormatPDF": "PDF",
    "reportFormatExcel": "எக்செல்",
    "reportFormatCSV": "சிஎஸ்வி",
    "enterValuePlaceholder": "மதிப்பை உள்ளிடவும்"
  },
  businessProfile: {
    "no_business_profile": "வணிக சுயவிவரம் இல்லை",
    "no_business_profile_description": "உங்கள் வணிக சுயவிவரத்தை நீங்கள் இன்னும் அமைக்கவில்லை என்று தெரிகிறது.",
    "create_business_profile": "வணிக சுயவிவரத்தை உருவாக்கவும்",
    "failed_to_fetch_business_profile": "வணிக சுயவிவரத்தைப் பெறுவதில் தோல்வி",
    "could_not_fetch_business_profile": "வணிக சுயவிவரத்தைப் பெற முடியவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "flower_vendor": "பூ விற்பனையாளர்",
    "grocery_store": "மளிகைக் கடை",
    "textile_shop": "ஜவுளிக்கடை",
    "hardware_store": "வன்பொருள் கடை",
    "electronics_shop": "எலக்ட்ரானிக்ஸ் கடை"
  },
  businessSettings: {
    "businessSettings": "வணிக அமைப்புகள்",
    "currency": "நாணயம்",
    "setCurrency": "உங்கள் வணிகத்திற்கான இயல்புநிலை நாணயத்தை அமைக்கவும்.",
    "language": "மொழி",
    "setLanguage": "உங்கள் கணக்கிற்கான மொழியை அமைக்கவும்.",
    "timezone": "நேர மண்டலம்",
    "setTimezone": "உங்கள் வணிகத்திற்கான நேர மண்டலத்தை அமைக்கவும்.",
    "notifications": "அறிவிப்புகள்",
    "lowStockAlerts": "குறைந்த பங்கு எச்சரிக்கைகள்",
    "lowStockDescription": "குறைந்த பங்கு பொருட்களுக்கான எச்சரிக்கைகளைப் பெறுங்கள்.",
    "expiringItems": "காலாவதியாகும் பொருட்கள்",
    "expiringItemsDescription": "காலாவதி தேதிக்கு அருகில் உள்ள பொருட்களுக்கான எச்சரிக்கைகளைப் பெறுங்கள்.",
    "orderUpdates": "ஆர்டர் புதுப்பிப்புகள்",
    "orderUpdatesDescription": "புதிய ஆர்டர்கள் மற்றும் ஆர்டர் நிலை மாற்றங்களுக்கான எச்சரிக்கைகளைப் பெறுங்கள்.",
    "select": "தேர்ந்தெடு",
    "updateFailed": "புதுப்பிப்பு தோல்வியுற்றது",
    "loadingError": "அமைப்புகளை ஏற்றுவதில் தோல்வி",
    "inr": "இந்திய ரூபாய் (INR)",
    "usd": "அமெரிக்க டாலர் (USD)",
    "en": "ஆங்கிலம்",
    "hi": "இந்தி",
    "te": "தெலுங்கு",
    "ta": "தமிழ்",
    "kn": "கன்னடம்",
    "ml": "മലையாளம்",
    "kolkata": "ஆசியா/கொல்கத்தா"
  },
  profile: {
    "profile": "சுயவிவரம்",
    "manage_your_account_settings": "உங்கள் கணக்கு அமைப்புகளை நிர்வகிக்கவும்",
    "active": "செயலில்",
    "business": "வணிகம்",
    "business_profile": "வணிக சுயவிவரம்",
    "business_settings": "வணிக அமைப்புகள்",
    "subscription": "சந்தா",
    "reports_and_analytics": "அறிக்கைகள் மற்றும் பகுப்பாய்வுகள்",
    "account": "கணக்கு",
    "edit_profile": "சுயவிவரத்தைத் திருத்து",
    "security_and_privacy": "பாதுகாப்பு மற்றும் தனியுரிமை",
    "settings": "அமைப்புகள்",
    "preferences": "விருப்பத்தேர்வுகள்",
    "advance_view": "முன்னேற்றக் காட்சி",
    "help_and_support": "உதவி மற்றும் ஆதரவு",
    "about_soma": "சோமா பற்றி",
    "sign_out": "வெளியேறு",
    "logout": "வெளியேறு",
    "are_you_sure_you_want_to_logout": "நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?"
  },
  dashboard: {
    dashboard: "டாஷ்போர்டு",
    business_overview: "வணிகக் கண்ணோட்டம்",
    action_required: "நடவடிக்கை தேவை",
    profile_incomplete_message: "உங்கள் வணிகச் சுயவிவரம் முழுமையடையவில்லை. தொடர தேவையான விவரங்களை வழங்கவும்.",
    complete_profile: "சுயவிவரத்தை முடிக்கவும்",
    quick_actions: "விரைவான நடவடிக்கைகள்",
    add_sale: "விற்பனையைச் சேர்க்கவும்",
    manage_stock: "பங்குகளை நிர்வகிக்கவும்",
    view_orders: "ஆர்டர்களைப் பார்க்கவும்",
    todays_overview: "இன்றைய கண்ணோட்டம்",
    weeks_overview: "இந்த வாரக் கண்ணோட்டம்",
    months_overview: "இந்த மாதக் கண்ணோட்டம்",
    low_stock: "குறைந்த இருப்பு",
    business_management: "வணிக மேலாண்மை",
    inventory_management_subtitle: "தயாரிப்புகள் மற்றும் பங்குகளை நிர்வகிக்கவும்",
    order_management_subtitle: "ஆர்டர்களைக் கண்காணித்து நிறைவேற்றவும்",
    purchase_management_subtitle: "கொள்முதல்களைக் கண்காணித்து நிர்வகிக்கவும்",
    customer_management_subtitle: "வாடிக்கையாளர் உறவுகளை நிர்வகிக்கவும்",
    supplier_management_subtitle: "சப்ளையர் உறவுகளை நிர்வகிக்கவும்",
    business_analytics_subtitle: "செயல்திறன் அளவீடுகளைப் பார்க்கவும்",
    welcome_back: "மீண்டும் வருக",
    orders_need_attention: "கவனம் தேவைப்படும் ஆர்டர்கள்",
    total_revenue: "மொத்த வருவாய்",
    active_orders: "செயலில் உள்ள ஆர்டர்கள்",
    stock_value: "பங்கு மதிப்பு",
    total_customers: "மொத்த வாடிக்கையாளர்கள்",
    live: "லைவ்",
    monthly_sales: "மாதாந்திர விற்பனை",
    view_details: "விவரங்களைப் பார்க்கவும்",
    recent_orders: "சமீபத்திய ஆர்டர்கள்",
    view_all: "அனைத்தையும் பார்க்கவும்",
    order_id: "ஆர்டர் ஐடி",
    customer: "வாடிக்கையாளர்",
    amount: "தொகை",
    status: "நிலை",
    important_tasks: "முக்கியமான பணிகள்",
    in_stock: "கையிருப்பில்",
    buy_more: "மேலும் வாங்கவும்",
    manage_inventory: "சரக்கு மேலாண்மை",
    goals: "இலக்குகள்",
    sales_goal: "விற்பனை இலக்கு",
    revenue_goal: "வருவாய் இலக்கு",
    search_placeholder: "ஆர்டர்கள், வாடிக்கையாளர்கள் அல்லது தயாரிப்புகளைத் தேடுங்கள்...",
    loading: "ஏற்றுகிறது..."
  },
  analytics: {
    title: "பகுப்பாய்வு",
    subtitle: "வணிக செயல்திறன் நுண்ணறிவு",
    last_7_days: "கடந்த 7 நாட்கள்",
    last_30_days: "கடந்த 30 நாட்கள்",
    last_3_months: "கடந்த 3 மாதங்கள்",
    business_reports: "வணிக அறிக்கைகள்",
    sales_forecast: "விற்பனை முன்னறிவிப்பு",
    reports_library: "அறிக்கை நூலகம்",
    total_revenue: "மொத்த வருவாய்",
    average_order_value: "சராசரி ஆர்டர் மதிப்பு",
    growth_rate: "வளர்ச்சி விகிதம்",
    total_orders: "மொத்த ஆர்டர்கள்",
    sales_by_channel: "சேனல் மூலம் விற்பனை",
    sales_breakdown: "விற்பனை விவரம்",
    online_sales: "ஆன்லைன் விற்பனை",
    store_sales: "கடை விற்பனை",
    wholesale_sales: "மொத்த விற்பனை",
    ai_suggestions: "AI பரிந்துரைகள்",
    ai_insight_1: "சரக்கு உகப்பாக்கம்",
    ai_insight_1_desc: "கையிருப்பு இல்லாமல் போவதைத் தடுக்க 'பிரீமியம் பட்டுப் புடவை'யை மறுவரிசைப்படுத்துவதைக் கவனியுங்கள்.",
    next_month: "அடுத்த மாதம்",
    next_3_months: "அடுத்த 3 மாதங்கள்",
    accuracy: "துல்லியம்",
    sales_growth: "விற்பனை வளர்ச்சி",
    sales_growth_subtitle: "கடந்த மாதத்துடன் ஒப்பிடும்போது மதிப்பிடப்பட்ட வளர்ச்சி",
    search_reports: "அறிக்கை வார்ப்புருக்களைத் தேடுங்கள்...",
    reports_available: "அறிக்கைகள் உள்ளன",
    no_reports: "அறிக்கைகள் எதுவும் கிடைக்கவில்லை",
    no_reports_desc: "வேறு தேடல் சொற்களை முயற்சிக்கவும் அல்லது புதிய தனிப்பயன் அறிக்கையை உருவாக்கவும்.",
    report_name: "அறிக்கை பெயர்",
    system_default: "கணினி இயல்புநிலை",
    description: "விளக்கம்",
    actions: "நடவடிக்கைகள்",
    edit: "திருத்து",
    generate: "உருவாக்கு"
  },
  // business: {
  //   profile: "Business Profile",
  //   edit_profile: "Edit Profile",
  //   create_profile: "Create Business Profile",
  //   edit_business_profile: "Edit Business Profile",
  //   create_business_profile: "Create Business Profile",
  //   no_profile_found: "No Business Profile Found",
  //   no_business_profile: "No Business Profile Found",
  //   no_business_profile_description: "You haven't set up your business profile yet. Create one to unlock all features.",
  //   go_back: "Go Back",
  //   basic_info: "Basic Information",
  //   business_name: "Business Name",
  //   enter_name: "Enter business name",
  //   business_type: "Business Type",
  //   select_type: "Select business type",
  //   email: "Email",
  //   phone: "Phone",
  //   address: "Address",
  //   enter_address: "Enter complete address",
  //   category: "Category",
  //   select_category: "Select category",
  //   annual_turnover: "Annual Turnover",
  //   select_turnover: "Select turnover range",
  //   gst_registered: "GST Registered",
  //   gst_number: "GST Number",
  //   registration_date: "Registration Date",
  //   flower_vendor: "Flower Vendor",
  //   grocery_store: "Grocery Store",
  //   textile_shop: "Textile Shop",
  //   hardware_store: "Hardware Store",
  //   electronics_shop: "Electronics Shop",
  //   other: "Other",
  //   retailer: "Retailer",
  //   wholesaler: "Wholesaler",
  //   manufacturer: "Manufacturer",
  //   service_provider: "Service Provider",
  //   gst_configuration: "GST Configuration",
  //   enabled: "Enabled",
  //   disabled: "Disabled",
  //   gstin_number: "GSTIN Number",
  //   default_cgst: "Default CGST (%)",
  //   default_sgst: "Default SGST (%)",
  //   default_igst: "Default IGST (%)",
  //   auto_sync: "Auto-sync invoices with GST portal",
  //   business_settings: "Business Settings",
  //   manage_business_preferences: "Manage your business preferences and configurations",
  //   general_settings: "General Settings",
  //   configure_general_settings: "Configure basic business settings",
  //   language: "Language",
  //   select_language: "Select Language",
  //   currency: "Currency",
  //   select_currency: "Select Currency",
  //   timezone: "Timezone",
  //   select_timezone: "Select Timezone",
  //   notifications: "Notifications",
  //   manage_notification_preferences: "Manage your notification preferences",
  //   low_stock_alerts: "Low Stock Alerts",
  //   low_stock_description: "Get notified when inventory runs low",
  //   expiring_items: "Expiring Items",
  //   expiring_items_description: "Get notified about items nearing expiration",
  //   order_updates: "Order Updates",
  //   order_updates_description: "Get notified about new orders and status changes",
  //   save_changes: "Save Changes",
  //   saving: "Saving...",
  //   cancel: "Cancel",
  //   create_profile_btn: "Create Profile",
  //   yes: "Yes",
  //   no: "No",
  //   n_a: "N/A",
  //   settings_saved_successfully: "Settings saved successfully",
  //   failed_to_save_settings: "Failed to save settings",
  //   failed_to_load_settings: "Failed to load settings",
  //   profile_updated: "Profile updated successfully",
  //   business_profile_created: "Business profile created successfully!",
  //   error_saving: "An error occurred while saving",
  //   error_creating: "An error occurred while creating profile",
  //   could_not_fetch_business_profile: "Could not fetch business profile",
  //   business_profile_not_found: "Business profile not found",
  //   not_provided: "Not provided",
  //   business_label: "Business"
  // },

  security_page: {
    hero_badge: "பாதுகாப்பு",
    hero_title: "வங்கி-தர பாதுகாப்பு",
    hero_subtitle: "உங்கள் வணிகத்திற்காக.",
    hero_desc: "உங்கள் வணிகத் தரவு நிறுவன-தர பாதுகாப்பு நடவடிக்கைகளுடன் பாதுகாக்கப்படுகிறது. நாங்கள் பாதுகாப்பை தீவிரமாக எடுத்துக்கொள்கிறோம் மற்றும் உங்கள் தரவைப் பாதுகாப்பாக வைத்திருக்க தொடர்ந்து முதலீடு செய்கிறோம்.",
    measures_title: "எங்கள் பாதுகாப்பு நடவடிக்கைகள்",
    measures_desc: "பாதுகாப்பின் பல அடுக்குகள் ஒவ்வொரு மட்டத்திலும் உங்கள் தரவைப் பாதுகாக்கின்றன.",
    compliance_title: "இணக்கம் & சான்றிதழ்கள்",
    compliance_desc: "நாங்கள் இணக்கம் மற்றும் பாதுகாப்பு சான்றிதழ்களின் மிக உயர்ந்த தரத்தைப் பராமரிக்கிறோம்.",
    best_practices_title: "பாதுகாப்பு சிறந்த நடைமுறைகள்",
    best_practices_desc: "இந்த சிறந்த நடைமுறைகளைப் பின்பற்றுவதன் மூலம் உங்கள் கணக்கைப் பாதுகாப்பாக வைத்திருக்க எங்களுக்கு உதவுங்கள்:",
    reporting_title: "பாதுகாப்பு சிக்கல்களைப் புகாரளித்தல்",
    reporting_desc: "நீங்கள் ஒரு பாதுகாப்பு பாதிப்பைக் கண்டறிந்தால் அல்லது பாதுகாப்பு குறித்து கவலைகள் இருந்தால், உடனடியாக எங்களுக்குப் புகாரளிக்கவும்.",
    responsible_disclosure: "பொறுப்பான வெளிப்படுத்தல்",
    responsible_disclosure_desc: "பாதுகாப்பு பாதிப்புகளை பொறுப்புடன் வெளிப்படுத்துவதை நாங்கள் பாராட்டுகிறோம். தயவுசெய்து பாதுகாப்பு விவரங்களை மின்னஞ்சல் செய்யவும்:",
    contact_team: "பாதுகாப்பு குழுவைத் தொடர்பு கொள்ளவும்",
    view_privacy: "தனியுரிமைக் கொள்கையைப் பார்க்கவும்",
    priority_title: "உங்கள் பாதுகாப்பு எங்கள் முன்னுரிமை",
    priority_desc: "உங்கள் வணிகத் தரவைப் பாதுகாக்க பாதுகாப்பு உள்கட்டமைப்பு மற்றும் சிறந்த நடைமுறைகளில் நாங்கள் தொடர்ந்து முதலீடு செய்கிறோம். பாதுகாப்பு குறித்து கேள்விகள் உள்ளதா? நாங்கள் உதவ இங்கே இருக்கிறோம்.",
    feature_encryption: "முனை-முதல்-முனை குறியாக்கம்",
    feature_encryption_desc: "எல்லா தரவும் AES-256 குறியாக்கத்தைப் பயன்படுத்தி குறியாக்கம் செய்யப்படுகிறது. உங்கள் வணிகத் தரவு வங்கி-தர பாதுகாப்பு தரங்களுடன் பாதுகாக்கப்படுகிறது.",
    feature_audits: "வழக்கமான பாதுகாப்பு தணிக்கைகள்",
    feature_audits_desc: "சாத்தியமான பாதுகாப்பு சிக்கல்களை முன்கூட்டியே கண்டறிந்து நிவர்த்தி செய்ய வழக்கமான பாதுகாப்பு தணிக்கைகள், ஊடுருவல் சோதனை மற்றும் பாதிப்பு மதிப்பீடுகளை நாங்கள் நடத்துகிறோம்.",
    feature_access: "அணுகல் கட்டுப்பாடுகள்",
    feature_access_desc: "பங்கு அடிப்படையிலான அணுகல் கட்டுப்பாடு (RBAC) பயனர்களுக்குத் தேவையான தரவு மற்றும் அம்சங்களுக்கான அணுகலை மட்டுமே உறுதி செய்கிறது. மேம்பட்ட பாதுகாப்பிற்காக பல காரணி அங்கீகாரம் (MFA) கிடைக்கிறது.",
    feature_backups: "தரவு காப்புப்பிரதிகள்",
    feature_backups_desc: "தானியங்கி தினசரி காப்புப்பிரதிகள் உங்கள் தரவு பாதுகாப்பாக இருப்பதை உறுதி செய்கின்றன. காப்புப்பிரதிகள் குறியாக்கம் செய்யப்பட்டு புவியியல் ரீதியாக விநியோகிக்கப்பட்ட தரவு மையங்களில் சேமிக்கப்படுகின்றன.",
    feature_compliance: "இணக்கம் & சான்றிதழ்கள்",
    feature_compliance_desc: "நாங்கள் டிஜிட்டல் தனிநபர் தரவு பாதுகாப்பு சட்டம் (DPDP சட்டம்) மற்றும் SOC 2 வகை II இணக்கத்தைப் பராமரிக்கிறோம். வழக்கமான இணக்கத் தணிக்கைகள் நாங்கள் மிக உயர்ந்த தரங்களைச் சந்திக்கிறோம் என்பதை உறுதிப்படுத்துகின்றன.",
    feature_incident: "சம்பவ மறுமொழி",
    feature_incident_desc: "எங்கள் பாதுகாப்புக் குழு அமைப்புகளை 24/7 கண்காணிக்கிறது மற்றும் விரிவான சம்பவ மறுமொழித் திட்டத்தைக் கொண்டுள்ளது. எந்தவொரு பாதுகாப்பு சம்பவத்திலும் பாதிக்கப்பட்ட பயனர்களுக்கு உடனடியாக அறிவிப்போம்.",
    practice_passwords: "உங்கள் சோமா கணக்கிற்கு வலுவான, தனித்துவமான கடவுச்சொற்களைப் பயன்படுத்தவும்",
    practice_mfa: "கூடுதல் பாதுகாப்பிற்காக பல காரணி அங்கீகாரத்தை (MFA) இயக்கவும்",
    practice_access: "பயனர் அணுகல் அனுமதிகளை தவறாமல் மதிப்பாய்வு செய்து புதுப்பிக்கவும்",
    practice_contact: "பாதுகாப்பு அறிவிப்புகளுக்காக உங்கள் தொடர்புத் தகவலைப் புதுப்பித்த நிலையில் வைத்திருங்கள்",
    practice_logout: "பகிரப்பட்ட அல்லது பொது கணினிகளிலிருந்து வெளியேறவும்",
    practice_report: "ஏதேனும் சந்தேகத்திற்கிடமான செயல்பாட்டை உடனடியாக security@soma.com க்கு புகாரளிக்கவும்",
    comp_dpdp: "DPDP சட்ட இணக்கம்",
    comp_dpdp_desc: "இந்தியாவின் டிஜிட்டல் தனிநபர் தரவு பாதுகாப்பு சட்டத்துடன் முழுமையான இணக்கம்",
    comp_soc2: "SOC 2 வகை II",
    comp_soc2_desc: "பாதுகாப்பு, கிடைக்கும் தன்மை மற்றும் ரகசியத்தன்மைக்கு சான்றளிக்கப்பட்டது",
    comp_iso: "ISO 27001",
    comp_iso_desc: "தகவல் பாதுகாப்பு மேலாண்மை அமைப்பு சான்றளிக்கப்பட்டது",
    comp_gst: "GST இணக்கம்",
    comp_gst_desc: "இந்திய விதிமுறைகளின்படி வரி தரவின் பாதுகாப்பான கையாளுதல்",
    compliance_disclaimer: "* பாதுகாப்பு தரங்கள் மற்றும் சான்றிதழ்கள் எங்கள் மேம்பாட்டு சாலை வரைபடம் மற்றும் இணக்க இலக்குகளின் ஒரு பகுதியாகும்.",
    reporting_ack: "நாங்கள் 24 மணி நேரத்திற்குள் ரசீதை ஒப்புக்கொள்வோம் மற்றும் சிக்கலை உடனடியாகத் தீர்க்க உங்களுடன் பணியாற்றுவோம்."
  },
  subscription_page: {
    subscription: "சந்தா",
    manage_subscription: "உங்கள் சந்தா திட்டம் மற்றும் பில்லிங் விவரங்களை நிர்வகிக்கவும்.",
    current_plan: "தற்போதைய திட்டம்",
    gst_settings: "GST அமைப்புகள்",
    gst_settings_desc: "உங்கள் GST அமைப்புகளை நிர்வகிக்கவும் மற்றும் உங்கள் வணிக இணக்கம் மற்றும் விலைப்பட்டியலுக்கு GST அம்சங்களை இயக்கவும்.",
    available_plans: "கிடைக்கும் திட்டங்கள்",
    plan_name: "திட்டத்தின் பெயர்",
    free_tier: "இலவச அடுக்கு",
    included_features: "உள்ளடங்கிய அம்சங்கள்",
    no_active_subscription: "செயலில் உள்ள சந்தா எதுவும் இல்லை.",
    loading: "ஏற்றுகிறது...",
    configure_gst: "GST கட்டமைக்கவும்",
    processing: "செயலாக்குகிறது...",
    upgrade_plan: "திட்டத்தை மேம்படுத்தவும்",
    error_fetch_subscription: "சந்தா விவரங்களைப் பெற முடியவில்லை.",
    error_generic_subscription: "சந்தா விவரங்களைப் பெறும்போது பிழை ஏற்பட்டது.",
    error_select_plan: "மேம்படுத்த ஒரு திட்டத்தைத் தேர்ந்தெடுக்கவும்.",
    success_upgrade: "சந்தா வெற்றிகரமாக மேம்படுத்தப்பட்டது!",
    error_upgrade: "சந்தாவை மேம்படுத்த முடியவில்லை.",
    error_upgrade_generic: "சந்தாவை மேம்படுத்தும்போது பிழை ஏற்பட்டது.",
    error_business_not_found: "வணிக சுயவிவரம் காணப்படவில்லை. தயவுசெய்து முதலில் ஒன்றை உருவாக்கவும்.",
    error_fetch_business: "வணிக விவரங்களைப் பெற முடியவில்லை."
  },
  purchases_page: {
    delete_confirmation: "இந்தக் கொள்முதலை நீக்கவா?",
    id_date: "ஐடி / தேதி",
    supplier: "சப்ளையர்",
    amount: "தொகை",
    before_tax: "வரிக்கு முன்",
    status: "நிலை",
    payment_status: "கட்டண நிலை",
    actions: "செயல்கள்",
    purchases: "கொள்முதல்",
    manage_purchases: "உங்கள் கொள்முதல் மற்றும் கொடுப்பனவுகளை நிர்வகிக்கவும்",
    add_purchase: "கொள்முதல் சேர்க்க",
    total_purchases: "மொத்த கொள்முதல்",
    total_spent: "மொத்த செலவு",
    pending_purchases: "நிலுவையில் உள்ள கொள்முதல்",
    pending_payment: "நிலுவையில் உள்ள கட்டணம்",
    search_placeholder: "சப்ளையர் பெயர் அல்லது கொள்முதல் ஐடி மூலம் தேடவும்...",
    all: "அனைத்தும்",
    pending: "நிலுவையில்",
    unpaid: "செலுத்தப்படாத",
    no_purchases: "கொள்முதல் இல்லை",
    no_purchases_desc: "கொள்முதல் எதுவும் கிடைக்கவில்லை",
    paid: "செலுத்தப்பட்டது",
    partial: "பகுதி"
  },
  placeholders: {
      select_language: "Select Language",
      select_timezone: "Select Timezone",
      enter_business_name: "Enter business name",
      select_business_type: "Select business type",
      enter_email: "business@example.com",
      enter_phone: "+91 98765 43210",
      enter_address: "Enter complete address",
      select_category: "Select category",
      select_turnover_range: "Select turnover range",
      gstin_placeholder: "22AAAAA0000A1Z5"
    },
    suppliers_page: {
      suppliers: "சப்ளையர்கள்",
      manage_suppliers: "உங்கள் சப்ளையர்கள் மற்றும் கொள்முதல்களை நிர்வகிக்கவும்",
      add_new_supplier: "புதிய சப்ளையரைச் சேர்க்கவும்",
      total_suppliers: "மொத்த சப்ளையர்கள்",
      total_purchases: "மொத்த கொள்முதல்",
      active_suppliers: "செயலில் உள்ள சப்ளையர்கள்",
      success_rate: "வெற்றி விகிதம்",
      search_suppliers: "பெயர் அல்லது தொடர்பு நபர் மூலம் தேடவும்...",
      no_suppliers: "சப்ளையர்கள் இல்லை",
      edit_supplier: "சப்ளையரைத் திருத்தவும்",
      delete_supplier: "சப்ளையரை நீக்கவும்",
      supplier_name: "சப்ளையர் பெயர்",
      contact_person: "தொடர்பு நபர்",
      phone: "தொலைபேசி",
      email: "மின்னஞ்சல்",
      gstin: "GSTIN",
      address: "முகவரி",
      cancel: "ரத்துசெய்",
      save: "சேமி",
      delete_confirmation: "இந்த சப்ளையரை நீக்க விரும்புகிறீர்களா?",
      actions: "செயல்கள்",
      add_supplier: "சப்ளையரைச் சேர்க்கவும்",
      update_supplier: "சப்ளையரைப் புதுப்பிக்கவும்",
      supplier_details: "சப்ளையர் விவரங்கள்",
      status: "நிலை",
      general_liaison: "பொது தொடர்பு",
      terms_net: "விதிமுறைகள்: நிகர",
      no_suppliers_desc: "சப்ளையர்கள் யாரும் காணப்படவில்லை"
    },
    orders_page: {
      title: "ஆர்டர்கள்",
      description: "உங்கள் அனைத்து ஆர்டர்களையும் நிர்வகிக்கவும்",
      create_new_order: "புதிய ஆர்டரை உருவாக்கவும்",
      total_orders: "மொத்த ஆர்டர்கள்",
      pending_orders: "நிலுவையில் உள்ள ஆர்டர்கள்",
      completed_orders: "முடிந்த ஆர்டர்கள்",
      direct_sales: "நேரடி விற்பனை",
      search_placeholder: "ஆர்டர் ஐடி அல்லது வாடிக்கையாளர் பெயர் மூலம் தேடவும்...",
      filter_all: "அனைத்தும்",
      filter_pending: "நிலுவையில்",
      filter_completed: "முடிந்தது",
      no_orders: "ஆர்டர்கள் இல்லை",
      no_orders_desc: "ஆர்டர்கள் எதுவும் கிடைக்கவில்லை",
      delete_confirmation: "இந்த ஆர்டரை நீக்கவா?",
      col_order_id: "ஆர்டர் ஐடி",
      col_customer_name: "வாடிக்கையாளர் பெயர்",
      guest: "விருந்தினர்",
      col_order_status: "ஆர்டர் நிலை",
      standard: "தரநிலை",
      col_amount: "தொகை",
      total: "மொத்தம்",
      col_actions: "செயல்கள்",
      wire: "வயர்",
      error_loading_sample: "ஏற்றுகிறது... மாதிரி தரவைக் காட்டுகிறது"
    },
    gst_page: {
      tax_gst: "வரி & GST",
      manage_gst: "உங்கள் GST வருமானம் மற்றும் வரி இணக்கத்தை நிர்வகிக்கவும்",
      export_report: "வரி அறிக்கையை ஏற்றுமதி செய்யவும்",
      input_tax_credit: "உள்ளீட்டு வரி கடன்",
      tax_liability: "வரி பொறுப்பு",
      pending_returns: "நிலுவையில் உள்ள வருமானம்",
      compliance_score: "இணக்க மதிப்பெண்",
      gstin_check: "GSTIN காசோலை",
      gst_returns: "GST வருமானம்",
      auto_file_gst: "தானியங்கி கோப்பு GST",
      past_returns: "கடந்த வருமானம்",
      gstin_verification: "GSTIN சரிபார்ப்பு",
      verify_gst_desc: "அரசாங்க தரவுத்தளத்துடன் GST எண்ணைச் சரிபார்க்கவும்.",
      verify_gst_subdesc: "எந்தவொரு 15 இலக்க GST எண்ணையும் உடனடி முடிவுகளுடன் விரைவாகச் சரிபார்க்கவும்.",
      enter_gst_number: "15 இலக்க GST எண்ணை உள்ளிடவும்...",
      check_gst_number: "GST எண்ணைச் சரிபார்க்கவும்",
      checking: "சரிபார்க்கிறது...",
      gst_verified: "GST எண் சரிபார்க்கப்பட்டது",
      verified_successfully: "வெற்றிகரமாக சரிபார்க்கப்பட்டது",
      business_name: "வணிகப் பெயர்",
      state: "மாநிலம்",
      invalid_gst_number: "தவறான GST எண்",
      gst_not_valid: "GST எண் செல்லுபடியாகாது",
      all_returns_filed: "அனைத்து வருமானங்களும் தாக்கல் செய்யப்பட்டன",
      returns_up_to_date: "உங்கள் GST வருமானம் புதுப்பித்த நிலையில் உள்ளது",
      gstr1_sales: "GSTR-1 (விற்பனை)",
      feature_auto_pop: "அம்சம்: விலைப்பட்டியலில் இருந்து தானியங்கி மக்கள்தொகை",
      coming_soon: "விரைவில் வரும்",
      gstr3b_summary: "GSTR-3B (சுருக்கம்)",
      feature_liability: "அம்சம்: ஒரு கிளிக் பொறுப்பு ஆஃப்செட்",
      history_coming_soon: "வரலாற்று அம்சம் விரைவில் வரும்.",
      return_type: "திரும்பும் வகை",
      period: "காலம்",
      due_date: "கடைசி தேதி",
      status: "நிலை",
      actions: "செயல்கள்",
      submit_return: "திரும்ப சமர்ப்பிக்கவும்"
    },
  customers_page: {
      customers: "வாடிக்கையாளர்கள்",
      manage_customers: "உங்கள் வாடிக்கையாளர்கள் மற்றும் கொடுப்பனவுகளை நிர்வகிக்கவும்",
      add_new_customer: "புதிய வாடிக்கையாளரைச் சேர்க்கவும்",
      total_customers: "மொத்த வாடிக்கையாளர்கள்",
      paid_customers: "கட்டணம் செலுத்திய வாடிக்கையாளர்கள்",
      pending_payments: "நிலுவையில் உள்ள கொடுப்பனவுகள்",
      total_due: "மொத்த நிலுவை",
      search_placeholder: "பெயர், மின்னஞ்சல் அல்லது தொலைபேசி மூலம் தேடவும்...",
      all: "அனைத்தும்",
      paid: "செலுத்தப்பட்டது",
      due: "நிலுவை",
      no_customers: "வாடிக்கையாளர்கள் இல்லை",
      no_customers_desc: "வாடிக்கையாளர்கள் யாரும் காணப்படவில்லை",
      customer_name: "வாடிக்கையாளர் பெயர்",
      id: "ஐடி",
      contact_details: "தொடர்பு விவரங்கள்",
      current_status: "தற்போதைய நிலை",
      pending_payment: "நிலுவையில் உள்ள கட்டணம்",
      amount_due: "நிலுவைத் தொகை",
      actions: "செயல்கள்",
      delete_confirmation: "இந்த வாடிக்கையாளரை நீக்கவா?",
      status_pending: "நிலுவையில் உள்ள கட்டணம்",
      status_no_dues: "நிலுவைகள் இல்லை",
      last_active: "கடைசியாக செயலில்"
    },

  inventory_page: {
    inventory: "சரக்கு",
    manage_inventory: "உங்கள் தயாரிப்புகள் மற்றும் பங்கு நிலைகளை நிர்வகிக்கவும்",
    add_product: "தயாரிப்பைச் சேர்க்கவும்",
    total_items: "மொத்த பொருட்கள்",
    low_stock: "குறைந்த இருப்பு",
    out_of_stock: "இருப்பு இல்லை",
    stock_value: "பங்கு மதிப்பு",
    search_placeholder: "குறியீடு, பெயர் அல்லது வகை மூலம் தயாரிப்புகளைத் தேடுங்கள்...",
    all_items: "அனைத்து பொருட்கள்",
    product_name: "தயாரிப்பு பெயர்",
    product_code: "தயாரிப்பு குறியீடு",
    stock_status: "பங்கு நிலை",
    price: "விலை",
    before_tax: "வரிக்கு முன்",
    actions: "செயல்கள்",
    in_stock: "கையிருப்பில்",
    units: "அலகுகள்",
    delete_confirmation: "இந்த தயாரிப்பை நீக்கவா?",
    no_products: "தயாரிப்புகள் இல்லை",
    no_products_desc: "தயாரிப்புகள் எதுவும் கிடைக்கவில்லை",
    edit_product: "தயாரிப்பைத் திருத்தவும்",
    delete_product: "தயாரிப்பை நீக்கவும்",
    loading_sample_data: "ஏற்றுகிறது... மாதிரி தரவைக் காட்டுகிறது"
  },
  business_settings_page: {
    business_settings: "வணிக அமைப்புகள்",
    manage_business_preferences: "உங்கள் வணிக முன்னுரிமைகள் மற்றும் உள்ளமைவுகளை நிர்வகிக்கவும்",
    general_settings: "பொதுவான அமைப்புகள்",
    configure_general_settings: "அடிப்படை வணிக அமைப்புகளை உள்ளமைக்கவும்",
    language: "மொழி",
    currency: "நாணயம்",
    select_currency: "நாணயத்தைத் தேர்ந்தெடுக்கவும்",
    timezone: "நேர மண்டலம்",
    select_timezone: "நேர மண்டலத்தைத் தேர்ந்தெடுக்கவும்",
    notifications: "அறிவிப்புகள்",
    manage_notification_preferences: "உங்கள் அறிவிப்பு முன்னுரிமைகளை நிர்வகிக்கவும்",
    low_stock_alerts: "குறைந்த இருப்பு எச்சரிக்கைகள்",
    low_stock_description: "சரக்கு குறைவாக இருக்கும்போது அறிவிக்கப்படும்",
    expiring_items: "காலாவதியாகும் பொருட்கள்",
    expiring_items_description: "காலாவதியாகும் பொருட்கள் பற்றி அறிவிக்கப்படும்",
    order_updates: "ஆர்டர் புதுப்பிப்புகள்",
    order_updates_description: "புதிய ஆர்டர்கள் மற்றும் நிலை மாற்றங்கள் பற்றி அறிவிக்கப்படும்",
    saving: "சேமிக்கிறது...",
    save_changes: "மாற்றங்களைச் சேமிக்கவும்",
    failed_to_load_settings: "அமைப்புகளை ஏற்ற முடியவில்லை",
    settings_saved_successfully: "அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன",
    failed_to_save_settings: "அமைப்புகளைச் சேமிக்க முடியவில்லை"
  },
  billing_page: {
    title: "நிதி மற்றும் பில்லிங்",
    subtitle: "கார்ப்பரேட் சந்தாக்கள் மற்றும் வளத் தீர்வுக்கான கட்டமைப்பு",
    tabs: {
      subscription: "சந்தா",
      history: "வரலாறு",
      settlements: "தீர்வுகள்",
      corporate_profile: "கார்ப்பரேட் சுயவிவரம்"
    },
    subscription: {
      tier_status: "அடுக்கு நிலை",
      authenticated: "அங்கீகரிக்கப்பட்டது",
      renewal: "புதுப்பித்தல்: ",
      ascend_plan: "திட்டத்தை மேம்படுத்தவும்",
      equilibrium_method: "சமநிலை முறை",
      recent_settlement: "சமீபத்திய தீர்வு",
      verified: "சரிபார்க்கப்பட்டது"
    },
    history: {
      invoice_identifier: "விலைப்பட்டியல் அடையாளம்",
      issuance_date: "வழங்கிய தேதி",
      settlement_amount: "தீர்வுத் தொகை",
      status: "நிலை",
      actions: "செயல்கள்",
      no_history_title: "தீர்வு வரலாறு இல்லை",
      no_history_desc: "அங்கீகரிப்பிற்குப் பிறகு உங்கள் சரிபார்க்கப்பட்ட விலைப்பட்டியல்கள் இங்கே தோன்றும்."
    },
    settlements: {
      architecture_title: "தீர்வு கட்டமைப்பு",
      architecture_desc: "அங்கீகரிக்கப்பட்ட கார்ப்பரேட் அணுகல் புள்ளிகள்",
      initialize_method: "முறையைத் தொடங்கவும்",
      no_vectors: "தீர்வு திசையன்கள் எதுவும் அடையாளம் காணப்படவில்லை"
    },
    profile: {
      corporate_identity: "கார்ப்பரேட் அடையாளம்",
      tax_protocol: "வரி நெறிமுறை / GSTIN",
      registered_address: "பதிவு செய்யப்பட்ட முகவரி",
      metropolis: "நகரம்",
      jurisdiction: "அதிகார வரம்பு",
      postal_code: "அஞ்சல் குறியீடு",
      sovereignty: "இறைமை",
      synchronizing: "ஒத்திசைக்கிறது...",
      authorize_updates: "புதுப்பிப்புகளை அங்கீகரிக்கவும்",
      update_success: "பில்லிங் தகவல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது"
    }
  },
  locations_page: {
    title: "இடங்கள்",
    subtitle: "பல இடங்கள் மற்றும் பங்கு இடமாற்றங்களை நிர்வகிக்கவும்",
    transfer_stock: "பங்கு பரிமாற்றம்",
    add_location: "இடத்தைச் சேர்",
    total_locations: "இடங்கள்",
    active_locations: "செயலில் உள்ள இடங்கள்",
    total_stock: "மொத்த பங்கு",
    transfers_progress: "செயல்பாட்டில் உள்ள இடமாற்றங்கள்",
    tabs: {
      locations: "இடங்கள்",
      all_stock: "அனைத்து இடங்களின் பங்கு",
      transfers: "பங்கு இடமாற்றங்கள்",
      analytics: "பகுப்பாய்வு"
    },
    table: {
      location_name: "இடத்தின் பெயர்",
      type: "வகை",
      address: "முகவரி",
      contact: "தொடர்பு",
      status: "நிலை",
      actions: "செயல்கள்",
      active: "செயலில்",
      inactive: "செயலற்றது",
      store: "கடை",
      warehouse: "கிடங்கு",
      view_details: "விவரங்களைக் காண்க",
      edit: "திருத்து",
      delete: "நீக்கு"
    },
    transfer_table: {
      date: "பரிமாற்ற தேதி",
      date_label: "தேதி",
      route: "இருந்து → வரை"
    },
    empty_state: {
      no_locations: "இடங்கள் எதுவும் காணப்படவில்லை",
      no_locations_desc: "நீங்கள் இன்னும் எந்த இடங்களையும் சேர்க்கவில்லை. தொடங்க ஒரு கடை அல்லது கிடங்கைச் சேர்க்கவும்.",
      no_transfers: "இடமாற்றங்கள் எதுவும் காணப்படவில்லை",
      no_transfers_desc: "நீங்கள் இன்னும் எந்த பங்கு இடமாற்றங்களையும் தொடங்கவில்லை.",
      no_stock: "பங்கு தரவு இல்லை",
      no_stock_desc: "தேர்ந்தெடுக்கப்பட்ட இடத்திற்கு பங்கு தரவு எதுவும் இல்லை."
    },
    analytics: {
      sales_analysis: "விற்பனை பகுப்பாய்வு",
      coming_soon: "மேம்பட்ட பகுப்பாய்வுகள் விரைவில்."
    }
  },
  usage_page: {
    title: "பயன்பாடு மற்றும் வரம்புகள்",
    subtitle: "உங்கள் பயன்பாடு மற்றும் வரம்புகளைப் பார்க்கவும்",
    export_report: "அறிக்கையை ஏற்றுமதி செய்",
    cards: {
      api_calls: "API அழைப்புகள்",
      storage_used: "சேமிப்பக பயன்பாடு",
      data_transfer: "தரவு பரிமாற்றம்",
      processing_time: "செயலாக்க நேரம்"
    },
    tabs: {
      system_status: "அமைப்பு நிலை",
      usage_limits: "பயன்பாட்டு வரம்புகள்",
      usage_history: "பயன்பாட்டு வரலாறு",
      alerts: "எச்சரிக்கைகள்"
    },
    monitor: {
      system_health: "கணினி ஆரோக்கியம்",
      current_system_status: "தற்போதைய கணினி நிலை",
      uptime: "இயக்க நேரம்",
      response_time: "பதில் நேரம்",
      errors: "பிழைகள்",
      database_usage: "தரவுத்தள பயன்பாடு",
      auto_scaling: "தானியங்கி அளவிடுதல்",
      system_running_smoothly: "கணினி சீராக இயங்குகிறது.",
      system_running_desc: "பயன்பாட்டின் அடிப்படையில் வளங்களை கணினி தானாகவே நிர்வகிக்கிறது. வேகமான செயல்திறனுக்காக கணினி நன்றாக இயங்குகிறது.",
      manage_auto_scaling: "தானியங்கி அளவிடுதலை நிர்வகி"
    },
    quotas: {
      usage_limit: "பயன்பாட்டு வரம்பு",
      used: "பயன்படுத்தப்பட்டது",
      total_limit: "மொத்த வரம்பு"
    },
    history: {
      date: "தேதி",
      api_calls: "API அழைப்புகள்",
      storage: "சேமிப்பு",
      data_transfer: "தரவு பரிமாற்றம்",
      reqs: "கோரிக்கைகள்",
      no_history: "வரலாறு இல்லை",
      no_history_desc: "பயன்பாட்டு வரலாறு இங்கே தோன்றும்"
    },
    alerts: {
      fix_issue: "சிக்கலைச் சரிசெய்",
      all_systems_good: "அனைத்து அமைப்புகளும் நன்றாக உள்ளன",
      no_issues_found: "சிக்கல்கள் எதுவும் காணப்படவில்லை"
    }
  },
  sidebar: {
    menu: {
      overview: "கண்ணோட்டம்",
      business: "வணிகம்",
      finance: "நிதி",
      system: "அமைப்பு"
    },
    items: {
      dashboard: "டாஷ்போர்டு",
      analytics: "பகுப்பாய்வு",
      business_profile: "வணிக சுயவிவரம்",
      inventory: "சரக்கு",
      orders: "ஆர்டர்கள்",
      purchases: "கொள்முதல்",
      customers: "வாடிக்கையாளர்கள்",
      suppliers: "விநியோகஸ்தர்கள்",
      business_settings: "வணிக அமைப்புகள்",
      tax_gst: "வரி & GST",
      billing: "பில்லிங்",
      subscription: "சந்தா",
      locations: "இடங்கள்",
      settings: "அமைப்புகள்",
      usage: "பயன்பாடு"
    },
    footer: {
      upgrade_pro: "Pro-க்கு மேம்படுத்தவும்",
      account: "கணக்கு",
      billing: "பில்லிங்",
      notifications: "அறிவிப்புகள்",
      logout: "வெளியேறு"
    }
  }
};